var app = angular.module('app-shop', ['app-account-service', 'app-cart-service', 'app-helpers', 'Giant.Analytics', 'ngSanitize', 'rzSlider']);

app.controller('Shop', ['$scope', '$http', '$window', '$timeout', '$sce', '$analytics', 'helpers', '$rootScope', 'cartService', 'accountService', function ($scope, $http, $window, $timeout, $sce, $analytics, helpers, $rootScope, cartService, accountService) {
    $scope.init = function () {
        log('Shop controller initialized.');
        $scope.updateCart(function () {
            //Start checkout GA
            try {
                trackEventGlobalAndLocalGA4({
                    'ga4_name': 'begin_checkout',
                    'ga4_currency': window.currencyCode,
                    'ga4_value': $scope.Cart.TotalIncludingShippingCosts,
                    'ga4_items': $scope.GetGACartItems()
                });

                //$analytics.createBuilder().asBeginCheckout({
                //    currency: window.currencyCode,
                //    value: $scope.Cart.TotalIncludingShippingCosts,
                //    items: $scope.GetGACartItems()
                //}).send();
            } catch (e) {
                //speciaal voor Brave browser die er uit klapt.
            }
        }, 'Initiation');
    };
    $scope.dealers = [];
    $scope.localdealers = [];
    $scope.localstockDealers = [];
    $scope.partnumber = '';
    $scope.dealercity = $window.defaultCity;
    $scope.productTypeId = $window.productTypeId;
    $scope.productId = $window.productId;
    $scope.latitude = '';
    $scope.longitude = '';
    $scope.localstockonly = false;
    $scope.take = 10;
    $scope.skip = 0;
    $scope.total = 0;
    $scope.localdealersCountFiltered = 0;
    $scope.nowarehousestock = false;
    $scope.containsLocalstock = false;
    $scope.errorContactInfo = '';
    $scope.formHasBeenSent = false;
    $scope.isSending = false;
    $scope.errorLogin = '';
    $scope.errorPayment = '';
    $scope.errorShippingOption = '';
    $scope.errorDealerSelect = '';
    $scope.contactinfoHTML = '';
    $scope.googleMapsAddressValidationResultJson = '';
    $scope.isValidContactInfo = false;
    $scope.isValidShippingOption = false;
    $scope.isValidSelectedDealer = false;
    /*$scope.isValidGiftcardOrCoupon = false;*/
    /*$scope.isValidCycleSchemeOrCoupon = false;*/
    $scope.isValidPayment = false;
    $scope.isValidSummary = false;
    $scope.axaptaConsumerAccountNumber = '';
    $scope.checkTermsAndConditions = false;
    $scope.checkPrivacy = null;
    $scope.paymentKey = '';
    $scope.cardholderName = '';
    $scope.expirationDate = '';
    $scope.last4Digits = '';
    $scope.creditcardType = '';
    $scope.proceedPaymentButtonClicked = false;
    $scope.proceedContactInfoButtonClicked = false;
    $scope.proceedLoginButtonClicked = false;
    $scope.proceedShippingOptionButtonClicked = false;
    $scope.proceedSelectDealerButtonClicked = false;
    $scope.proceedSummaryButtonClicked = false;
    $scope.ShippingOption = {};
    $scope.Cart = {};
    $scope.Cart.Loaded = false;
    $scope.totalPriceWithTaxAndShipping = 0;
    $scope.OutOfStockValidation = {};
    $scope.IsWarning = false;
    $scope.lockedCart = '';
    $scope.issuer = '';
    $scope.employeeNumber = '';
    $scope.IOS = false;
    $scope.showPersonalData = false;
    $scope.paymentButtonDisabled = false;
    $scope.mercadopageShowInstallments = false;
    $scope.stripe3ErrorMessage = '';
    $scope.V12paymentCalculated = {};
    $scope.V12FinanceProduct = {
        Selected: '',
        DepositValue: 250,
        changeDepositValue: function () {
            if ($scope.V12FinanceProduct.DepositValue < $scope.V12Slider.options.minLimit) {
                $scope.V12FinanceProduct.DepositValue = $scope.V12Slider.options.minLimit;
            } else if ($scope.V12FinanceProduct.DepositValue > $scope.V12Slider.options.ceil) {
                $scope.V12FinanceProduct.DepositValue = $scope.V12Slider.options.ceil;
            } else if ($scope.V12FinanceProduct.DepositValue < $scope.V12Slider.options.floor) {
                $scope.V12FinanceProduct.DepositValue = $scope.V12Slider.options.floor;
            }
        },
        CalculateV12: function (product) {
            var purchaseValue = $scope.Cart.TotalIncludingShippingCosts;
            var monthlypaymentResult = parseFloat((purchaseValue - $scope.V12FinanceProduct.DepositValue) * product.CalculationFactor);

            if (product.ProductId == $scope.V12FinanceProduct.Selected) {
                var productId = $scope.V12FinanceProduct.Selected; // selected product
                var financeProduct = V12.getFinanceProduct(productId); // get the object
                var cashPrice = purchaseValue;
                //var depositFactor = $scope.V12FinanceProduct.DepositValue;
                //var deposit = parseInt(Math.ceil(cashPrice * depositFactor)) / 100; // 9/1/2018 V12
                //deposit = parseFloat(deposit.toFixed(2));							// 9/1/2018 V12
                $scope.V12paymentCalculated = V12.calculate(financeProduct, cashPrice, $scope.V12FinanceProduct.DepositValue);
                $scope.V12Slider.options.ceil = Math.floor(purchaseValue - financeProduct.minLoan);
                if ($scope.V12Slider.options.ceil > (purchaseValue * 0.5)) {
                    $scope.V12Slider.options.ceil = Math.floor(purchaseValue * 0.5); //deposit >= MinLoan en <= 50% van het totaal (zie mail Tom)
                }
                //$scope.V12Slider.options.floor = financeProduct.minLoan;
                $scope.V12Slider.options.floor = 0;
                this.changeDepositValue();
            }

            return monthlypaymentResult.toFixed(2);
        }
    };
    $scope.slider = '';
    $scope.couponcode = '';
    $scope.coupon = null;
    $scope.promotion = null;
    $scope.showPasswordForgotten = false;
    $scope.imagesToPartnumbers = [];
    $scope.color = '';
    $scope.colors = [];
    $scope.colorCodes = [];
    $scope.partnumbers = [];
    $scope.partnumbersWithUsage = [];
    $scope.stocks = [];
    $scope.stock = {};
    $scope.product = {};
    $scope.consorsFinanzLabel = '';
    $scope.santanderFinanceLabel = '';
    $scope.sofincoFinanceLabel = '';
    $scope.AlphacreditLabel = '';
    $scope.v12FinanceProducts = [];
    $scope.v12Label = '';
    $scope.OrderConfirmation = '';
    $scope.countryId = countryId;
    $scope.onlineSizerProductFound = false;
    $scope.containsValidAddress = true;
    $scope.klarnaAuthorizationToken = null;
    $scope.AppleGooglePayAvailable = false;
    $scope.GAclientId = function () {
        var ga_clientId;
        try {
            if (ga.getAll()[0].get('clientId') != undefined) {
                ga_clientId = ga.getAll()[0].get('clientId');
            }
        } catch (e) {
            //do nothing
        }
        return ga_clientId;
    }
    $scope.supplementaryItemPartnumberCode = '';
    $scope.supplementaryItem = null;
    $scope.availableStatesUSA = [
        { key: 'AL', value: 'Alabama' },
        { key: 'AK', value: 'Alaska' },
        { key: 'AZ', value: 'Arizona' },
        { key: 'AR', value: 'Arkansas' },
        { key: 'CA', value: 'California' },
        { key: 'CO', value: 'Colorado' },
        { key: 'CT', value: 'Connecticut' },
        { key: 'DE', value: 'Delaware' },
        { key: 'DC', value: 'District of Columbia' },
        { key: 'FL', value: 'Florida' },
        { key: 'GA', value: 'Georgia' },
        { key: 'HI', value: 'Hawaii' },
        { key: 'ID', value: 'Idaho' },
        { key: 'IL', value: 'Illinois' },
        { key: 'IN', value: 'Indiana' },
        { key: 'IA', value: 'Iowa' },
        { key: 'KS', value: 'Kansas' },
        { key: 'KY', value: 'Kentucky' },
        { key: 'LA', value: 'Louisiana' },
        { key: 'ME', value: 'Maine' },
        { key: 'MD', value: 'Maryland' },
        { key: 'MA', value: 'Massachusetts' },
        { key: 'MI', value: 'Michigan' },
        { key: 'MN', value: 'Minnesota' },
        { key: 'MS', value: 'Mississippi' },
        { key: 'MO', value: 'Missouri' },
        { key: 'MT', value: 'Montana' },
        { key: 'NE', value: 'Nebraska' },
        { key: 'NV', value: 'Nevada' },
        { key: 'NH', value: 'New Hampshire' },
        { key: 'NJ', value: 'New Jersey' },
        { key: 'NM', value: 'New Mexico' },
        { key: 'NY', value: 'New York' },
        { key: 'NC', value: 'North Carolina' },
        { key: 'ND', value: 'North Dakota' },
        { key: 'OH', value: 'Ohio' },
        { key: 'OK', value: 'Oklahoma' },
        { key: 'OR', value: 'Oregon' },
        { key: 'PA', value: 'Pennsylvania' },
        { key: 'PR', value: 'Puerto Rico' },
        { key: 'RI', value: 'Rhode Island' },
        { key: 'SC', value: 'South Carolina' },
        { key: 'SD', value: 'South Dakota' },
        { key: 'TN', value: 'Tennessee' },
        { key: 'TX', value: 'Texas' },
        { key: 'UT', value: 'Utah' },
        { key: 'VT', value: 'Vermont' },
        { key: 'VA', value: 'Virginia' },
        { key: 'WA', value: 'Washington' },
        { key: 'WV', value: 'West Virginia' },
        { key: 'WI', value: 'Wisconsin' },
        { key: 'WY', value: 'Wyoming' }
    ];

    $scope.availableStatesCA = [
        { key: 'AB', value: 'Alberta' },
        { key: 'BC', value: 'British Columbia' },
        { key: 'MB', value: 'Manitoba' },
        { key: 'NB', value: 'New Brunswick' },
        { key: 'NL', value: 'Newfoundland and Labrador' },
        { key: 'NS', value: 'Nova Scotia' },
        { key: 'NT', value: 'Northwest Territories' },
        { key: 'NU', value: 'Nunavut' },
        { key: 'ON', value: 'Ontario' },
        { key: 'PE', value: 'Prince Edward Island' },
        { key: 'QC', value: 'Quebec' },
        { key: 'SK', value: 'Saskatchewan' },
        { key: 'YT', value: 'Yukon' }
    ];

    $scope.creditcardAddress = {
        useShippingAddress: false,
        name: '',
        street: '',
        zipcode: '',
        city: '',
        state: ''
    };
    $scope.completeInProgress = '';
    $scope.userExists = false;
    $scope.simplefyCCNumberValid = false;
    $scope.simplefyCVVCodeValid = false;
    $scope.simplefyExpValid = false;
    $scope.simplefyValid = function () {
        return $scope.simplefyCCNumberValid && $scope.simplefyCVVCodeValid && $scope.simplefyExpValid;
    };

    $scope.toggleUseShippingAddress = function () {
        if ($scope.creditcardAddress.useShippingAddress) {
            if ($scope.firstname != undefined) {
                $scope.creditcardAddress.name = $scope.firstname + ' ' + $scope.lastname;
                $scope.creditcardAddress.street = $scope.street;
                $scope.creditcardAddress.zipcode = $scope.postalcode;
                $scope.creditcardAddress.city = $scope.city;
                $scope.creditcardAddress.state = $scope.state;
            } else {
                //nieuwe manier
                $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                $scope.creditcardAddress.city = $scope.Cart.Order.City;
                $scope.creditcardAddress.state = $scope.Cart.Order.State;
            }
        } else {
            $scope.creditcardAddress.name = '';
            $scope.creditcardAddress.street = '';
            $scope.creditcardAddress.zipcode = '';
            $scope.creditcardAddress.city = '';
            $scope.creditcardAddress.state = '';
        }
    };

    $scope.getDealers = function (localstockonly, callback, startNew) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/dealers' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');

            if (localstockonly != undefined) {
                $scope.localstockonly = localstockonly;
            }
            if (startNew != undefined) {
                $scope.skip = 0;
            }

            //var lookupGeolocationUsingBrowser = false; //use this new feature only in test mode voor UK
            //if (window.inTestMode != undefined && window.inTestMode == true && window.countryId == 19) {
            var lookupGeolocationUsingBrowser = true;
            //get coordinates from cookie is necessary
            if (($scope.latitude == undefined || $scope.latitude == '') && readCookie('defaultLatitude') != undefined && readCookie('defaultLatitude') != '') {
                $scope.latitude = readCookie('defaultLatitude');
                $scope.longitude = readCookie('defaultLongitude');
                $scope.dealercity = readCookie('defaultCity');
            }

            if ($scope.latitude != undefined && $scope.latitude != '') {//don't use browserlocation because user entered location manually
                lookupGeolocationUsingBrowser = false;
            }
            //}

            helpers.getBrowserLocation(function (lat, lng, dealercity) {
                $scope.latitude = lat != undefined && lat != '' ? lat : $scope.latitude;
                $scope.longitude = lng != undefined && lng != '' ? lng : $scope.longitude;
                $scope.dealercity = dealercity != undefined && dealercity != '' ? dealercity : $scope.dealercity;

                $http({
                    method: 'POST',
                    url: url,
                    data: {
                        partnumberCode: $scope.partnumber.code != undefined ? $scope.partnumber.code : null,
                        localstockOnly: $scope.localstockonly,
                        productType: $window.productTypeId != undefined ? $window.productTypeId : null,
                        productId: $window.productId != undefined ? $window.productId : null,
                        latitude: $scope.latitude,
                        longitude: $scope.longitude,
                        city: encodeURIComponent($scope.dealercity),
                        take: $scope.take,
                        skip: $scope.skip
                    },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            if (obj[p] != null) {
                                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                            }
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    if (startNew != undefined && startNew == true) {
                        $scope.dealers = res.data.dealers;
                    } else {
                        $scope.dealers = $scope.dealers.concat(res.data.dealers);
                    }
                    $scope.localstockDealers = res.data.localstockDealers;
                    $scope.dealercity = res.data.city != null ? res.data.city : $scope.dealercity;
                    $scope.productTypeId = res.data.productTypeId;
                    if (res.data.productId > 0) {
                        $scope.productId = res.data.productId;
                    } else {
                        try {
                            $scope.productId = productId;
                        } catch (e) {
                            //do nothing
                        }
                    }
                    $scope.total = res.data.total;
                    $scope.nowarehousestock = res.data.nowarehousestock;
                    $scope.containsLocalstock = res.data.containsLocalstock;
                    if (res.data.lockedCart != undefined) {
                        $scope.lockedCart = res.data.lockedCart;
                    }

                    if (callback) {
                        callback();
                    }

                    /*
                    SK+NS: switched off 19-08-2019
                    if (helpers.isMobile())
                        $timeout(function () {
                            $document.find('#localstockContainer').scrollToElement({ marginTop: $document.find('#clickandcollect').offset().top - 80 });
                        });
                    */

                })
            }, lookupGeolocationUsingBrowser,
                function () {
                    $scope.toggleProgressbarPartnumberSelect();
                }
            );
        });
    }

    $scope.getLocalDealers = function () {
        //Supplementary items doesn't support local dealer stock
        if ($scope.Cart.HasSupplementaryItems == undefined || $scope.Cart.HasSupplementaryItems == false) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/dealers' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');

                //var lookupGeolocationUsingBrowser = false; //use this new feature only in test mode voor UK
                //if ((window.inTestMode != undefined && window.inTestMode == true) || window.countryId == 19) {
                var lookupGeolocationUsingBrowser = true;
                if (($scope.latitude == undefined || $scope.latitude == '') && readCookie('defaultLatitude') != undefined && readCookie('defaultLatitude') != '') {
                    $scope.latitude = readCookie('defaultLatitude');
                    $scope.longitude = readCookie('defaultLongitude');
                    $scope.dealercity = readCookie('defaultCity');
                }

                if ($scope.latitude != undefined && $scope.latitude != '') {//don't use browserlocation because user entered location manually
                    lookupGeolocationUsingBrowser = false;
                }
                //}

                helpers.getBrowserLocation(function (lat, lng, dealercity) {
                    $scope.latitude = lat != undefined && lat != '' ? lat : $scope.latitude;
                    $scope.longitude = lng != undefined && lng != '' ? lng : $scope.longitude;
                    $scope.dealercity = dealercity != undefined && dealercity != '' ? dealercity : $scope.dealercity;

                    $http({
                        method: 'POST',
                        url: url,
                        data: {
                            partnumberCode: $scope.partnumber.code != undefined ? $scope.partnumber.code : null,
                            localstockOnly: true,
                            productType: $window.productTypeId != undefined ? $window.productTypeId : null,
                            productId: $window.productId != undefined ? $window.productId : null,
                            latitude: $scope.latitude,
                            longitude: $scope.longitude,
                            city: encodeURIComponent($scope.dealercity)
                        },
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        transformRequest: function (obj) {
                            //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                            var str = [];
                            for (var p in obj)
                                if (obj[p] != null) {
                                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                                }
                            return str.join("&");
                        },
                        withCredentials: true
                    }).then(function (res) {
                        $scope.localdealers = res.data.dealers;
                        if (res.data.lockedCart != undefined) {
                            $scope.lockedCart = res.data.lockedCart;
                        }

                        $scope.productTypeId = res.data.productTypeId;
                        if (res.data.productId > 0) {
                            $scope.productId = res.data.productId;
                        } else {
                            try {
                                $scope.productId = productId;
                            } catch (e) {
                                //do nothing
                            }
                        }

                        /*
                        SK+NS: switched off 19-08-2019
                        if (helpers.isMobile())
                            $timeout(function () {
                                $document.find('#localstockContainer').scrollToElement({ marginTop: $document.find('#clickandcollect').offset().top - 80 });
                            });
                        */
                    })
                },
                    lookupGeolocationUsingBrowser,
                    function () {
                        $scope.toggleProgressbarPartnumberSelect();
                    }
                );
            });
        }
    }

    $scope.toggleProgressbarPartnumberSelect = function () {
        //toggle showing progress bar
        //if ($('#partnumberSelect .dropdown-toggle').hasClass('btn-run-progress')) {
        //    $('#partnumberSelect .dropdown-toggle').removeClass('btn-run-progress');
        //} else {
        //    $('#partnumberSelect .dropdown-toggle').addClass('btn-run-progress');
        //}

        $scope.completeInProgress = $scope.completeInProgress != true;
    }

    $scope.showMoreDealers = function () {
        $scope.skip = $scope.skip + $scope.take;
        $scope.getDealers();
    }

    $scope.showMoreDealersLink = function () {
        if (($scope.skip + $scope.take) < $scope.total) {
            return true;
        } else {
            return false;
        }
    }

    $scope.resetDealers = function () {
        $scope.skip = 0;
        $scope.dealers = [];
    }

    $scope.selectSize = function (code, stock, productTypeId, notifyMe, shippingcosts) {
        if (productTypeId != undefined && productTypeId == 1) {
            $scope.partnumber = {
                code: code,
                stock: stock,
                type: productTypeId,
                shippingcosts: shippingcosts,
                notifyMe: notifyMe
            };
            //$scope.resetDealers();
            $scope.getLocalDealers();
            $scope.getDealers(null, null, true);
        }
    }


    $scope.openZoomScroller = function () {
        $(".zoomed-image-modal").addClass("zoomed-image-modal-active");
        $("body").addClass("bike-zoom-active");
        $('#zoomed-image-modal').scrollTop(0);
        openDialog($(".zoomed-image-modal")[0]);
        setTimeout(function () {
            $("#close-zoomed-image-list-modal").focus();
        }, 1000);
    }

    $scope.closeZoomScroller = function () {
        $(".zoomed-image-modal").removeClass("zoomed-image-modal-active");
        $("body").removeClass("bike-zoom-active");
        closeDialog();
        setTimeout(function () {
            $("#productImageList button:first").focus();
        }, 1000);
    }

    $scope.selectColor = function (nrOfSizes) {
        code = $("#colorSelector").find(':selected').attr('data-partnumbercode');
        stock = $("#colorSelector").find(':selected').attr('data-stockcode');

        var imagesToPartnumbers = helpers.getImagesToPartnumbers();
        if (imagesToPartnumbers.length > 0) {

            imagesToPartnumbers = imagesToPartnumbers.filter(function (image) {
                if (image.PartnumberCodes.indexOf(code) != -1) {
                    return image;
                }
            });

            if (imagesToPartnumbers.length > 0) {
                var images = $("img[name='mainImage']");
                if (images.length > 0) {
                    for (i = 0; i < images.length; i++) {
                        var imageSrc = images[i].src;
                        images[i].src = imageSrc.replace(imageSrc.substr(imageSrc.lastIndexOf('/') + 1), imagesToPartnumbers[0].CloudinaryImage);
                    }
                }
            }
        }

        if (nrOfSizes != undefined && nrOfSizes == 1) {
            $scope.partnumber = {
                code: code,
                stock: stock,
                type: $window.productTypeId
            };

            //$scope.resetDealers();
            $scope.getLocalDealers();
            $scope.getDealers(null, null, true);
        }
    }

    $scope.getDealersFiltered = function (limit, maxdistance) {
        var result = $scope.localdealers;
        if (maxdistance > 0 | limit > 0) {
            if ($scope.partnumber != null && $scope.partnumber.stock != undefined && ($scope.partnumber.stock == 'instock' || $scope.partnumber.stock.Code == 1 || $scope.partnumber.stock.Code == 3)) {
                result = [];
                for (var i = 0; i < $scope.localdealers.length; i++) {
                    if ($scope.localdealers[i].Distance <= maxdistance) {
                        result.push($scope.localdealers[i]);
                    }
                }
            }
            if (limit > 0) {
                result = result.slice(0, limit);
            }
            $scope.localdealersCountFiltered = result.length;
        }
        return result;
    }

    $scope.getOpeningHours = function (dealer) {
        return $sce.trustAsHtml(dealer.Openinghours);
    };

    $scope.parseHtml = function (html) {
        return $sce.trustAsHtml(html);
    };

    $scope.getGeolocation = function (callback) {
        helpers.getGeolocation($scope.dealercity, function (lat, lng) {
            $scope.latitude = lat;
            $scope.longitude = lng;
            if (callback) {
                callback();
            }
        });
    };

    $scope.getGeolocationAndGetDealers = function (callback) {
        $scope.getGeolocation(function () {
            //$scope.resetDealers();
            $scope.getDealers(null, callback, true);
            $scope.getLocalDealers();
        });
    }

    $scope.getBrowserlocationAndGetDealers = function () {
        helpers.getBrowserLocation(function (lat, lng, dealercity) {
            //$scope.resetDealers();
            $scope.latitude = lat;
            $scope.longitude = lng;
            $scope.dealercity = dealercity;
            $scope.getDealers(null, null, true);
            $scope.getLocalDealers();
        });
    }

    $scope.hasLocalStock = function (dealer) {
        var result = false;

        for (var i = 0; i < $scope.localstockDealers.length; i++) {
            if ($scope.localstockDealers[i] == dealer.Code) {
                result = true;
                break;
            }
        }

        return result;
    }

    $scope.showGoogleMaps = function (dealer, viewMode, callback) {

        setTimeout(function () {
            var myLatLng = new google.maps.LatLng(dealer.Latitude, dealer.Longitude);
            var bounds = new google.maps.LatLngBounds();
            var mapOptions = {
                center: myLatLng,
                zoom: 10,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            }

            var mapCanvas = document.getElementById('map-canvas-' + viewMode + '-' + dealer.Code);
            var map = new google.maps.Map(mapCanvas, mapOptions);
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map
            });
            bounds.extend(marker.getPosition());
            google.maps.event.trigger(map, "resize");

            //if (callback) {
            //    callback();
            //}
        });
    }

    $scope.showStockAlert = function () {
        $('#stockAlertModal #partnumberCode').val($scope.partnumber.code);
        $('#stockAlertModal').modal('show');
    }

    $scope.showContactForm = function () {
        $('#contactModal').modal('show');
    }

    $scope.isPanelActive = function (panelName) {
        var scrollElement = "#" + panelName;
        return angular.element(scrollElement).is(':visible');
    }

    $scope.outOfStockValidation = function () {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/outofstockvalidation' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $scope.OutOfStockValidation = res.data;
                $scope.errorPayment = '';
                if ($scope.OutOfStockValidation.Message != null) {
                    $scope.errorPayment = $scope.OutOfStockValidation.Message;
                }
            });
        });
    }

    $scope.updateCart = function (callback, initiator) {
        cartService.getCart(initiator).then(function () {
            $scope.Cart = cartService._cart;
            $scope.Cart.Loaded = true;
            $scope.totalPriceWithTaxAndShipping = $scope.Cart.TotalIncludingShippingCosts;

            if (typeof window.syncVueCheckoutCartFromAngular === 'function') {
                window.syncVueCheckoutCartFromAngular(cartService._cart);
            }

            if ($scope.Cart.ShippingOptions != undefined && $scope.Cart.ShippingOptions.length > 0) {
                $scope.ShippingOption.selected = $scope.Cart.ShippingOptions.filter(function (value) { return value.Guid == $scope.Cart.ShippingGuid && value.Disabled == false })[0];
            }

            if ($scope.Cart.Order != null && (($scope.Cart.Order.Email != null && $scope.Cart.Order.Email.length > 0) || ($scope.Cart.Order.Phone != null && $scope.Cart.Order.Phone.length > 0))) {
                $scope.showPersonalData = true;
            }

            if ($('.affirm-as-low-as').length > 0) {
                //    //update Affirm value
                try {
                    affirm.ui.ready(function () {
                        affirm.ui.refresh();
                    });
                } catch (e) {
                    //do nothing
                }
            }

            if ($scope.Cart.PaymentOptions != undefined && $scope.Cart.PaymentOptions.length == 1) {
                $scope.selectPaymentOption($scope.Cart.PaymentOptions[0].code)
            }

            // Stripe3 checkout renders only the Payment Element (no payment radio). Cart JSON still lists all country methods, so length > 1 — set stripe3 explicitly.
            if (typeof window !== 'undefined' && window.hasSelectableStripe3InCheckout === true
                && $scope.Cart.TotalIncludingShippingCosts > 0
                && $scope.getPaymentOption('stripe3') != null) {
                $scope.selectPaymentOption('stripe3');
            }

            if ($scope.Cart.TotalIncludingShippingCosts == 0 && $scope.Cart.PaymentOptions != undefined) {
                for (var i = 0; i < $scope.Cart.PaymentOptions.length; i++) {
                    if ($scope.Cart.Coupon != undefined && $scope.Cart.Coupon.Value == 100 && $scope.Cart.Coupon.UnitId == 2) {
                        $scope.selectPaymentOption('coupon');
                    //} else if ($scope.Cart.PaymentOptions[i].code == 'giftcard') {
                    //    $scope.selectPaymentOption('giftcard');
                    //    break;
                    } else {
                        $scope.selectPaymentOption('coupon'); //$scope.Cart.TotalIncludingShippingCosts == 0 => Coupon dekt de volledige lading
                    }
                }
            }

            if ($scope.Cart.PaymentOptions != undefined && $scope.Cart.PaymentOptions.length > 0) {
                for (var i = 0; i < $scope.Cart.PaymentOptions.length; i++) {
                    var paymentoptioncode = $scope.Cart.PaymentOptions[i].code;
                    if (paymentoptioncode == 'stripeApplePay' || paymentoptioncode == 'stripeGooglePay' || paymentoptioncode == 'stripeGooglePayAndApplePay') {
                        if ($scope.AppleGooglePayAvailable == false) {
                            $scope.setPaymentOptionDisabled('stripeGooglePayAndApplePay');
                        } else {
                            $scope.setPaymentOptionEnabled('stripeGooglePayAndApplePay');
                        }
                    } else if (paymentoptioncode == 'paypalvenmo') {
                        paypal.getFundingSources().forEach(function (fundingSource) {
                            // Initialize the buttons
                            var button = paypal.Buttons({
                                fundingSource: fundingSource,
                            })
                            // Check if the button is eligible
                            if (fundingSource == 'venmo') {
                                if (button.isEligible() == false && window.inTestMode == undefined) {
                                    $scope.setPaymentOptionDisabled('paypalvenmo');
                                }
                                log('Venmo active: ' + button.isEligible().toString());
                            }
                        })
                    } else if (paymentoptioncode == 'mercadopago') {

                    }
                }
            }

            if ($scope.Cart.Coupon != undefined) {
                $scope.coupon = $scope.Cart.Coupon;
            }

            if ($scope.Cart.Promotion != undefined) {
                $scope.promotion = $scope.Cart.Promotion;
            }

            $scope.validateAddress();

            if (callback) {
                callback();
            }
        })
    }

    $scope.removeCartItem = function (item) {
        $scope.completeInProgress = true;
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/removecartitem/' + item.Id + '/json?expanded=true&r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $scope.updateCart(function () {
                    //Opnieuw out of stock bepalen. Zodat melding weg is.
                    $scope.outOfStockValidation();
                    $scope.completeInProgress = false;
                }, 'RemoveCartItem');
                $rootScope.$broadcast('cartUpdated');
                $scope.isValidContactInfo = false;
                $scope.isValidShippingOption = false;
                $scope.isValidSelectedDealer = false;
               /* $scope.isValidGiftcardOrCoupon = false;*/
                /*$scope.isValidCycleSchemeOrCoupon = false;*/
                $scope.isValidPayment = false;
                $scope.isValidSummary = false;
                $('#collapseContactInfo').collapse('show');
                $('#collapseShippingOptions').collapse('hide');
                $('#collapseDealers').collapse('hide');
                $('#collapsePayment').collapse('hide');
                $('#collapseSummary').collapse('hide');

                //suggestions from 55: This event is usually used for users clicking on blogs/articles. Therefore, it's unnecessary to send select_content event when users click add to cart or remove from cart.
                //AnalyticsBuilder.create(window.inTestMode ? { debug: true } : {}).addProduct({
                //    'id': item.Product.Partnumber != undefined ? item.Product.Partnumber.Code : '',
                //    'name': item.Product.Name,
                //    'quantity': item.Quantity,
                //    'price': item.Product.Partnumber != undefined ? item.Product.Partnumber._price : item.Product.PriceOriginal != undefined ? item.Product.PriceOriginal : '',
                //    'brand': item.Product.BrandName,
                //    'category': item.Product.GA_Category
                //}).asRemoveFromCart({
                //    'id': item.Product.Partnumber != undefined ? item.Product.Partnumber.Code : '',
                //    'name': item.Product.Name,
                //    'quantity': item.Quantity,
                //    'price': item.Product.Partnumber != undefined ? item.Product.Partnumber._price : item.Product.PriceOriginal != undefined ? item.Product.PriceOriginal : '',
                //    'brand': item.Product.BrandName,
                //    'category': item.Product.GA_Category
                //}).send();
            });
        });
    }

    $scope.removeDealer = function () {
        $scope.completeInProgress = true;
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/removedealer?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $scope.updateCart(null, 'RemoveDealer');
                $scope.isValidContactInfo = false;
                $scope.isValidShippingOption = false;
                $scope.isValidSelectedDealer = false;
                /*$scope.isValidGiftcardOrCoupon = false;*/
                /*$scope.isValidCycleSchemeOrCoupon = false;*/
                $scope.isValidPayment = false;
                $scope.isValidSummary = false;
                $scope.completeInProgress = false;
                $('#collapseContactInfo').collapse('show');
                $('#collapseShippingOptions').collapse('hide');
                $('#collapseDealers').collapse('hide');
                $('#collapsePayment').collapse('hide');
                $('#collapseSummary').collapse('hide');
            });
        });
    }

    $scope.showDealerSelector = function () {
        return $scope.ShippingOption.selected != undefined
            && ($scope.ShippingOption.selected.DeliveryType == 2 || $scope.ShippingOption.selected.DeliveryType == 3 || $scope.countryId == 14 || ($scope.countryId == 17 && $scope.ShippingOption.selected.DeliveryType != 5)) //uitzondering voor Frankrijk die bij direct delivery ook de dealer willen hebben
            && ($scope.Cart.Dealer == null || $scope.isValidSelectedDealer == true);


        //return $scope.Cart.ShowDealerSelector && ($scope.Cart.Dealer == null || $scope.isValidSelectedDealer == true);
        //TODO: Bij overhevelen naar VUE deze business logica server side opnemen => DONE
        //return ($scope.countryId == 19 || $scope.countryId == 48 || $scope.countryId == 6 || $scope.countryId == 29 || $scope.countryId == 14 || $scope.countryId == 15 || $scope.countryId == 17 || $scope.countryId == 13 || $scope.countryId == 40 || ($scope.countryId == 43 && $scope.ShippingOption != undefined && $scope.ShippingOption.selected != undefined && $scope.ShippingOption.selected.DeliveryType != undefined && $scope.ShippingOption.selected.DeliveryType != 1) || ($scope.Cart.ContainsOnlyGear == false && ($scope.ShippingOption.selected != null && $scope.ShippingOption.selected.OnlyDirectshipmentBikes == false))) && ($scope.Cart.Dealer == null || $scope.isValidSelectedDealer == true) && $scope.Cart.ContainsOnlyGiftcard == false;
    }

    $scope.ValidatedAddressAtGoogleMaps = false;
    $scope.ValidateAddressAtGoogleMaps = function () {
        getLatLng($scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City, function (a, b, c, d) {
            if (window.inTestMode != undefined && window.inTestMode == true) {
                try {
                    var googleMapsAddressValidationResultJson = JSON.stringify(d, null, 2);
                    $scope.googleMapsAddressValidationResultJson = googleMapsAddressValidationResultJson != undefined ? googleMapsAddressValidationResultJson : '';
                } catch (e) {
                    $scope.googleMapsAddressValidationResultJson = d != undefined ? d.toString() : '';
                }
            }

            try {
                if (d.length > 0) {
                    for (var i = 0; i < d[0].address_components.length; i++) {
                        if (d[0].address_components[i].types[0] == 'country') {
                            if (d[0].address_components[i].short_name.toLowerCase() == countryCode || ($scope.Cart.RelatedCountryCodes != null && $scope.Cart.RelatedCountryCodes.indexOf(d[0].address_components[i].short_name.toLowerCase()) > -1) || d[0].address_components[i].long_name.toLowerCase() == 'guernsey' || d[0].address_components[i].long_name.toLowerCase() == 'isle of man' || d[0].address_components[i].long_name.toLowerCase() == 'jersey') {
                                $scope.ValidatedAddressAtGoogleMaps = true;
                                $scope.$apply();
                                $scope.proceedContactInfoAfterValidation();
                                return true;
                            }
                        }
                    }
                }
            } catch (e) {
                //exceptionHandling(e.message, e.stack);
            }
            //exceptionHandling('Cart contains address different from country', 'Google Maps input: ' + $scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City + ' ' + country + '\nGoogle Maps result: ' + c);
            $scope.ValidatedAddressAtGoogleMaps = true;
            $scope.errorContactInfo = lblIncorrectAddress;
            $scope.proceedContactInfoButtonClicked = false;
            $scope.completeInProgress = false;
            $scope.$apply();
            return false;
        });
    }

    $scope.proceedCheckout = function () {
        $('.btn-run-progress').removeClass('btn-run-progress');
        $('#cartModal').modal('hide');
        window.location = '/' + $window.culture + '/shop/review/';
    }

    $scope.proceedContactInfo = function () {

        //check required fields
        $scope.errorContactInfo = '';
        $scope.proceedContactInfoButtonClicked = true;
        $scope.completeInProgress = true;
        if ($scope.formContactInfo.$valid) {

            // valid
            if (window.validateAddressAtLoqate != undefined && window.validateAddressAtLoqate == true) {
                helpers.validateAddress($scope.Cart.Order.Street, $scope.Cart.Order.Postalcode, $scope.Cart.Order.City, $scope.Cart.Order.Email, $scope.Cart.Order.Phone, $scope.Cart.Order.State, $scope.Cart.Order.LoqateKey, true,
                    function () {
                        $scope.proceedContactInfoAfterValidation();
                    },
                    function (address) {
                        $('#Order_OrderStreet').val(address.Line1);
                        $('#Order_OrderPostalcode').val(address.PostalCode);
                        $('#Order_OrderCity').val(address.City);
                        $('#Order_OrderState').val(address.Province);
                        $scope.Cart.Order.Street = address.Line1;
                        $scope.Cart.Order.Postalcode = address.PostalCode;
                        $scope.Cart.Order.City = address.City;
                        $scope.Cart.Order.State = address.Province;
                        $scope.$apply();

                        if ($scope.formContactInfo.$valid == false) {
                            $scope.errorContactInfo = lblMakeSureAllRequiredFieldsAreEntered;
                            $scope.$apply();
                        } else {
                            $scope.proceedContactInfoAfterValidation();
                        }
                    },
                    function (data) {
                        $scope.proceedContactInfoButtonClicked = false;
                        $scope.completeInProgress = false;

                        if (data != undefined) {
                            if (data.PhoneToFormat != null && data.PhoneToFormat.length > 0) {
                                $('#Order_OrderPhone').val(data.PhoneToFormat);
                                $scope.Cart.Order.Phone = data.PhoneToFormat;
                            }
                        }
                    }
                );
                //} else if ($scope.ValidatedAddressAtGoogleMaps == false && window.validateAddressAtGoogleMaps != undefined && window.validateAddressAtGoogleMaps == true) {
            } else if (window.validateAddressAtGoogleMaps != undefined && window.validateAddressAtGoogleMaps == true) {
                $scope.ValidateAddressAtGoogleMaps();
            } else {
                $scope.proceedContactInfoAfterValidation();
            }

            //push email to klaviyo
            //var preferences = $.gdprcookie.preference();
            //if (preferences.indexOf('statistics') > -1 && preferences.indexOf('marketing') > -1) {
            ////    klaviyo.push(['identify', {
            ////        // Change the line below to dynamically print the user's email.
            ////        '$email': $scope.Cart.Order.Email
            ////    }]);
            //    var _learnq = _learnq || [];
            //    _learnq.push(['identify', { '$email': $scope.Cart.Order.Email }]);
            //}

        } else {

            //if ($scope.formContactInfo.$error.required != undefined && $scope.formContactInfo.$error.required.length > 0) {
            //    $scope.errorContactInfo += lblMakeSureAllRequiredFieldsAreEntered;
            //}
            if ($scope.formContactInfo.$error.email != undefined && $scope.formContactInfo.$error.email.length > 0) {
                $scope.errorContactInfo += lblWrongEmailHasBeenEntered;
            } else {
                $scope.errorContactInfo += lblMakeSureAllRequiredFieldsAreEntered;
            }
            // SK 13-10-2020
            angular.element('input.ng-invalid').first().focus();
            $scope.completeInProgress = false;
        }

        //track GA
        trackEventGlobalAndLocal('Create account', 'Click', 'Checkout');
    }

    $scope.proceedContactInfoAfterValidation = function () {
        $scope.completeInProgress = true;
        $scope.contactinfoHTML = '';
        $scope.dealercity = $scope.postalcode + ' ' + $scope.city;
        var search = $scope.street + ' ' + $scope.postalcode + ' ' + $scope.city + ',' + country;
        if ($scope.state != undefined) {
            $scope.dealercity += ', ' + $scope.state;
        }

        //if (version != undefined && version == 2) {
        $scope.dealercity = $scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City;
        if ($scope.Cart.Order.State != undefined) {
            $scope.dealercity += ', ' + $scope.Cart.Order.State;
        }
        search = $scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City + ',' + country;
        //}

        getLatLng(search, function (lat, lng, formatted_address) {
            $('#Order_OrderLatitude').val(lat);
            $('#Order_OrderLongitude').val(lng);
            $('#Order_OrderGAclientId').val($scope.GAclientId());
            $scope.latitude = lat;
            $scope.longitude = lng;

            //submit form to collect contact info
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setcontactinfo' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: $('form[name="formOrder"]').serialize(),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    withCredentials: true
                }).then(function (res) {
                    $scope.isValidContactInfo = res.data.result;
                    $scope.isValidShippingOption = false;
                    $scope.isValidSelectedDealer = false;
                    /*$scope.isValidGiftcardOrCoupon = false;*/
                    /*$scope.isValidCycleSchemeOrCoupon = false;*/
                    $scope.isValidPayment = false;
                    $scope.isValidSummary = false;
                    if (res.data.result == true) {
                        $scope.contactinfoHTML = $sce.trustAsHtml(res.data.html);
                        $scope.axaptaConsumerAccountNumber = res.data.axaptaConsumerAccountNumber;
                        $scope.updateCart(function () {
                            // show and focus
                            //if ($scope.Cart.ContainsOnlyGiftcard == true) {
                            //    $('#collapsePayment').collapse('show');
                            //    document.getElementsByName('paymentoption')[0].focus();
                            //} else {
                                $('#collapseShippingOptions').collapse('show');
                                $('#collapseShippingOptions input:radio').focus();
                            /*}*/
                            // hide
                            $('#collapseContactInfo').collapse('hide');
                            /*$('#collapseContactInfo').removeClass('in');*/
                            $scope.proceedContactInfoButtonClicked = false;
                            $scope.completeInProgress = false;
                        }, 'SetContactInfo'); //especially for gear items. Tax will change.

                        //try {
                        //    $analytics.createBuilder().asCheckoutStep({
                        //        step: 1,
                        //        option: $scope.axaptaConsumerAccountNumber === '' ? 'NotLoggedIn' : 'LoggedIn',
                        //        checkout_step: 1,
                        //        checkout_option: $scope.axaptaConsumerAccountNumber === '' ? 'NotLoggedIn' : 'LoggedIn',
                        //        items: $scope.GetGACartItems()
                        //    }).send();
                        //} catch (e) {
                        //    //speciaal voor Brave browser die er uit klapt.
                        //}

                    } else {
                        $scope.proceedContactInfoButtonClicked = false;
                        $scope.completeInProgress = false;
                        if (res.data.userExists != undefined && res.data.userExists == true) {
                            $scope.userExists = true;
                        } else {
                            $scope.errorContactInfo = res.data.error;
                            // Find zipcode field
                            var zipCodeField = document.getElementById('Order_OrderPostalcode');
                            zipCodeField.focus();
                        }
                        $('#collapseShippingOptions').collapse('hide');

                    }
                });
            });
        });

    }


    $scope.Login = function () {
        $scope.completeInProgress = true;
        accountService.Login($scope.loginEmail, $scope.loginPassword, true, true).then(function () {
            if (accountService._account.result != null && accountService._account.result.Token.length > 0) {
                $scope.Cart.Order.Firstname = accountService._account.result.Details.OrderFirstname;
                $scope.Cart.Order.Lastname = accountService._account.result.Details.OrderLastname;
                $scope.Cart.Order.Street = accountService._account.result.Details.OrderStreet;
                $scope.Cart.Order.OrderAddress2 = accountService._account.result.Details.OrderAddress2;
                $scope.Cart.Order.Postalcode = accountService._account.result.Details.OrderPostalcode;
                $scope.Cart.Order.City = accountService._account.result.Details.OrderCity;
                $scope.Cart.Order.State = accountService._account.result.Details.OrderState;
                $scope.Cart.Order.Phone = accountService._account.result.Details.OrderPhone;
                $scope.Cart.Order.Email = accountService._account.result.Details.OrderEmail;
                $scope.Cart.Order.AxaptaConsumerAccountNumber = accountService._account.result.Details.OrderAxaptaConsumerAccountNumber;
                $scope.Cart.Order.Gender = accountService._account.result.Details.GenderToFormat;
                $scope.Cart.Order.BirthDate = accountService._account.result.Details.BirthDateToFormat;
                $scope.Cart.Order.AddToNewsletter = accountService._account.result.Details.OrderAddToNewsletter;
                $scope.showPersonalData = true;
                $scope.validateAddress();

                //GA4
                trackEventGlobalAndLocalGA4({ 'ga4_name': 'login', 'ga4_location': 'checkout' });
            } else {
                try {
                    $scope.errorLogin = accountService._account.error;
                } catch (e) {
                    $scope.errorLogin = 'An error occurred. Please try again';
                }

                // Find e-mail input field 
                var emailInputField = document.getElementById('Email');
                if (emailInputField == null) {
                    emailInputField = document.getElementById('loginEmail');
                }
                if (emailInputField != null) {
                    emailInputField.focus();
                }

            }
            $scope.completeInProgress = false;
        });

        //track GA
        trackEventGlobalAndLocal('Log in', 'Click', 'Checkout');
    }

    $scope.proceedLogin = function () {
        $scope.errorLogin = '';
        $scope.proceedLoginButtonClicked = true;

        if ($scope.formLogin.$valid) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/login' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: { email: $scope.loginEmail, password: $scope.loginPassword },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.error.length == 0) {
                        //if (version != undefined && version == 2) {
                        $scope.Cart.Order.Firstname = res.data.result.OrderFirstname;
                        $scope.Cart.Order.Lastname = res.data.result.OrderLastname;
                        $scope.Cart.Order.Street = res.data.result.OrderStreet;
                        $scope.Cart.Order.OrderAddress2 = res.data.result.OrderAddress2;
                        $scope.Cart.Order.Postalcode = res.data.result.OrderPostalcode;
                        $scope.Cart.Order.City = res.data.result.OrderCity;
                        $scope.Cart.Order.State = res.data.result.OrderState;
                        $scope.Cart.Order.Phone = res.data.result.OrderPhone;
                        $scope.Cart.Order.Email = res.data.result.OrderEmail;
                        $scope.Cart.Order.AxaptaConsumerAccountNumber = res.data.result.OrderAxaptaConsumerAccountNumber;

                        $('#loginModal').modal('hide');
                        //rename create account label
                        //$('#lnkCreateAccount').html(lblChangePassword);
                        $scope.errorLogin = '';
                        $scope.proceedLoginButtonClicked = false;
                    } else {
                        $scope.errorLogin = res.data.error;
                    }
                });
            });
        } else {
            if ($scope.formLogin.$error.required != undefined && $scope.formLogin.$error.required.length > 0) {
                $scope.errorLogin = lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formLogin.$error.email != undefined && $scope.formLogin.$error.email.length > 0) {
                $scope.errorLogin += lblWrongEmailHasBeenEntered;
            }
        }
    }

    $scope.Logout = function () {
        //GA4
        trackEventGlobalAndLocalGA4({ 'ga4_name': 'logout', 'ga4_location': 'checkout' });

        accountService.Logout();
    }

    $scope.LogoutGiantID = function () {
        $scope.completeInProgress = true;
        //GA4
        trackEventGlobalAndLocalGA4({ 'ga4_name': 'logout', 'ga4_location': 'checkout' });

        accountService.LogoutGiantID(function () { $scope.completeInProgress = false; });
    }

    $scope.proceedPasswordForgotten = function () {
        $http({
            method: 'POST',
            url: '/' + $window.culture + '/shop/resetpasswordrequest' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : ''),
            data: { email: $scope.loginEmail }
        }).then(function (res) {
            $scope.messagePasswordForgotten = '';
            $scope.errorPasswordForgotten = '';
            if (res.data.result == true) {
                $scope.messagePasswordForgotten = res.data.message;
            } else {
                $scope.errorPasswordForgotten = res.data.message;
            }
        });
    }

    $scope.selectShippingOption = function () {
        //var shippingOptionSelected = $scope.ShippingOption.selected;
        //if (shippingOptionSelected.OnlyDirectshipmentBikes == true) {
        //    $('#panel-dealerselector').hide();
        //    //$('#headingPayment .nr').text(parseInt($('#headingShippingOptions .nr').text()) + 1);
        //} else {
        //    $('#panel-dealerselector').show();
        //    //$('#headingPayment .nr').text(parseInt($('#headingShippingOptions .nr').text()) + 2);
        //}
    };

    $scope.proceedShippingOption = function () {
        $scope.errorShippingOption = '';
        $scope.proceedShippingOptionButtonClicked = true;
        $scope.completeInProgress = true;
        var shippingOptionSelected = $scope.ShippingOption.selected;

        if (shippingOptionSelected != null) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setshippingoption' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: { guid: shippingOptionSelected.Guid, latitude: $scope.latitude, longitude: $scope.longitude },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    $scope.isValidShippingOption = res.data.result;
                    if (res.data.result) {
                        $scope.isValidSelectedDealer = false;
                        /*$scope.isValidGiftcardOrCoupon = false;*/
                        /*$scope.isValidCycleSchemeOrCoupon = false;*/
                        $scope.isValidPayment = false;
                        $scope.isValidSummary = false;
                        if (shippingOptionSelected.DeliveryTypeToString == 'homedelivery' && $scope.Cart.UseLocalStock != undefined && $scope.Cart.UseLocalStock == false && $scope.Cart.Dealer != null) {
                            //remove dealer when switching to homedelivery and not local stock
                            $scope.removeDealer();
                        }

                        //set search dealer field at home address
                        $scope.dealercity = $scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City;

                        //UpdateCart();
                        $scope.updateCart(function () {
                            $scope.completeInProgress = false;

                            if ($scope.showDealerSelector()) {
                                $scope.getGeolocationAndGetDealers(function () {
                                    // show and focus (1360)
                                    $('#collapseDealers').collapse('show');
                                    $('#collapseDealers input:text').focus();
                                    // hide
                                    $('#collapseShippingOptions').collapse('hide');
                                    $scope.proceedShippingOptionButtonClicked = false;
                                });
                            //} else if ($('#panel-GiftcardOrCoupon').is(":visible")) {
                            //    // show and focus
                            //    $('#collapseGiftcardOrCoupon').collapse('show');
                            //    $('#collapseGiftcardOrCoupon input#Giftcard').focus();
                            //    // hide
                            //    $('#collapseShippingOptions').collapse('hide');
                            //    $scope.proceedShippingOptionButtonClicked = false;
                            } else {
                                // show and focus
                                $('#collapsePayment').collapse('show');
                                $('#collapsePayment input:radio').focus();
                                // hide
                                $('#collapseShippingOptions').collapse('hide');
                                $scope.proceedShippingOptionButtonClicked = false;
                            }

                            trackEventGlobalAndLocalGA4({ 'ga4_name': 'add_shipping_info', 'ga4_currency': window.currencyCode, 'ga4_value': $scope.Cart.Total, 'ga4_shipping_tier': shippingOptionSelected.Name + ($scope.Cart.Dealer != null ? ' - ' + $scope.Cart.Dealer.Name : ''), 'ga4_items': $scope.GetGACartItems() });
                        }, 'SetShippingOption');

                        $scope.isIOS();

                        /*try {
                            $analytics.createBuilder().asShippingOptionStep({
                                step: 2,
                                option: shippingOptionSelected.DeliveryTypeToString,
                                checkout_step: 2,
                                checkout_option: shippingOptionSelected.DeliveryTypeToString,
                                items: $scope.GetGACartItems()
                            }).send();
                        } catch (e) {
                            //speciaal voor Brave browser die er uit klapt.
                        }*/
                    } else {
                        //an error occured
                        $scope.errorShippingOption = res.data.message;
                        $scope.completeInProgress = false;
                    }
                });
            });
        } else {
            $scope.errorShippingOption = lblSelectDeliveryOption;
            $scope.completeInProgress = false;
        }
    }

    $scope.proceedSelectDealer = function (dealer) {
        $scope.proceedSelectDealerButtonClicked = dealer.Code;
        $scope.errorDealerSelect = '';
        $scope.completeInProgress = true;

        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/setdealercode' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                data: { dealercode: dealer.Code },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                withCredentials: true
            }).then(function (res) {
                if (res.data == 'True') {
                    $scope.updateCart(function () {
                        $scope.isValidSelectedDealer = true;
                        /*$scope.isValidGiftcardOrCoupon = false;*/
                        /*$scope.isValidCycleSchemeOrCoupon = false;*/
                        $scope.isValidPayment = false;
                        $scope.isValidSummary = false;
                        $scope.outOfStockValidation();

                        //if ($('#panel-GiftcardOrCoupon').is(":visible")) {
                        //    // show and focus
                        //    $('#collapseGiftcardOrCoupon').collapse('show');
                        //    $('#collapseGiftcardOrCoupon input#Giftcard').focus();
                        //    // hide
                        //    $('#collapseDealers').collapse('hide');
                        //    $scope.proceedSelectDealerButtonClicked = false;
                        //}
                        //else if ($('#panel-CycleSchemeOrCoupon').is(":visible")) {
                        //    $('#collapseCycleSchemeOrCoupon').collapse('show');
                        //    $('#collapseDealers').collapse('hide');
                        //    $scope.proceedSelectDealerButtonClicked = false;
                        //}
                        //else {
                            // show and focus
                        $('#collapsePayment').collapse('show');
                            if (document.getElementsByName('paymentoption') != null && document.getElementsByName('paymentoption').length > 0) {
                                document.getElementsByName('paymentoption')[0].focus();
                            }
                            // hide
                            $('#collapseDealers').collapse('hide');
                            $scope.proceedSelectDealerButtonClicked = false;
                        //}
                        $scope.completeInProgress = false;

                    }, 'SetDealerCode');

                    if ($scope.hasLocalStock(dealer)) {
                        //double check product is in local stock. Else show user message product is only in warehouse stock.
                        $scope.outOfStockValidation();
                    }

                    //try {
                    //    $analytics.createBuilder().asCheckoutStep({
                    //        step: 3,
                    //        checkout_step: 3,
                    //        checkout_option: 'dealer selected',
                    //        items: $scope.GetGACartItems()
                    //    }).send();
                    //} catch (e) {
                    //    //speciaal voor Brave browser die er uit klapt.
                    //}

                    //trackEventGlobalAndLocalGA4({ 'ga4_name': 'select_retailer', 'ga4_retailer_name': dealer.Name });

                } else {
                    $scope.errorDealerSelect = res.data;
                    $scope.proceedSelectDealerButtonClicked = '';
                    $scope.completeInProgress = false;
                }

                $scope.isIOS();
            });
        });

        trackEventGlobalAndLocalGA4({
            'ga4_name': 'select_retailer',
            'ga4_model_category': $scope.Cart != undefined && $scope.Cart.CartItems.length == 1 ? $scope.Cart.CartItems[0].Product.GA_Category : 'n/a',
            'ga4_model_name': $scope.Cart != undefined && $scope.Cart.CartItems.length == 1 ? $scope.Cart.CartItems[0].Product.Name : 'n/a',
            'ga4_retailer_name': dealer.Name
        });
    }

    $scope.proceedSetDeliveryAddress = function () {
        $scope.completeInProgress = true;

        //submit form to collect contact info
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/setcontactinfo' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                data: $('form[name="formOrder"]').serialize(),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                withCredentials: true
            }).then(function (res) {
                if (res.data.result == true) {
                    $scope.updateCart(function () {
                        $scope.isValidSelectedDealer = true;
                        /*$scope.isValidGiftcardOrCoupon = false;*/
                        /*$scope.isValidCycleSchemeOrCoupon = false;*/
                        $scope.isValidPayment = false;
                        $scope.isValidSummary = false;
                        $scope.outOfStockValidation();

                        //if ($('#panel-GiftcardOrCoupon').is(":visible")) {
                        //    // show and focus
                        //    $('#collapseGiftcardOrCoupon').collapse('show');
                        //    $('#collapseGiftcardOrCoupon input#Giftcard').focus();
                        //    // hide
                        //    $('#collapseDealers').collapse('hide');
                        //    $scope.proceedSelectDealerButtonClicked = false;
                        //}
                        //else {
                            // show and focus
                            $('#collapsePayment').collapse('show');
                            if (document.getElementsByName('paymentoption') != null && document.getElementsByName('paymentoption').length > 0) {
                                document.getElementsByName('paymentoption')[0].focus();
                            }
                            // hide
                            $('#collapseDealers').collapse('hide');
                            $scope.proceedSelectDealerButtonClicked = false;
                        //}
                        $scope.completeInProgress = false;
                    });
                } else {
                    $scope.completeInProgress = false;
                }
            });
        });

    }

    //$scope.proceedGiftcard = function () {
    //    if ($scope.giftcard != undefined) {
    //        /*            $scope.actionButtonGiftcardOrCouponClicked = true;*/
    //        $scope.completeInProgress = true;
    //        $scope.giftcard.Valid = true;
    //        cartService.MasterDomain().then(function () {
    //            var url = cartService._masterDomain + '/' + $window.culture + '/shop/validategiftcard' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
    //            $http({
    //                method: 'POST',
    //                url: url,
    //                data: { giftcard: $scope.giftcard.Number },
    //                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    //                transformRequest: function (obj) {
    //                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
    //                    var str = [];
    //                    for (var p in obj)
    //                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    //                    return str.join("&");
    //                },
    //                withCredentials: true
    //            }).then(function (res) {
    //                $scope.updateCart(function () {
    //                    /*$scope.actionButtonGiftcardOrCouponClicked = false;*/
    //                    $scope.completeInProgress = false;
    //                    if (res && res.data && res.data.Valid == false) {
    //                        $scope.giftcard.Valid = false;
    //                        $scope.giftcard.Message = res.data.Message;
    //                        angular.element('#Giftcard').focus();
    //                    } else {
    //                        $scope.giftcard = res.data;
    //                    }
    //                }, 'ValidateGiftcard');
    //            });
    //        });
    //    }
    //}

    //$scope.removeGiftcard = function (item) {
    //    $scope.actionButtonGiftcardOrCouponClicked = true;
    //    $scope.completeInProgress = true;
    //    cartService.MasterDomain().then(function () {
    //        var url = cartService._masterDomain + '/' + $window.culture + '/shop/removegiftcard' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
    //        $http({
    //            method: 'POST',
    //            url: url,
    //            data: { giftcardpublic: item },
    //            withCredentials: true
    //        }).then(function (res) {
    //            $scope.updateCart(function () {
    //                $scope.actionButtonGiftcardOrCouponClicked = false;
    //                $scope.completeInProgress = false;
    //            }, 'RemoveGiftcard');
    //        });
    //    });
    //}

    //$scope.proceedGiftcardOrCoupon = function () {
    //    $scope.errorGiftcardOrCoupon = '';
    //    $scope.proceedGiftcardOrCouponButtonClicked = true;

    //    /*$scope.isValidGiftcardOrCoupon = true;*/
    //    $('#collapsePayment').collapse('show');
    //    $('#collapseGiftcardOrCoupon').collapse('hide');
    //    $scope.proceedGiftcardOrCouponButtonClicked = false;

    //    //try {
    //    //    $analytics.createBuilder().asCheckoutStep({
    //    //        step: 4,
    //    //        option: shippingOptionSelected.DeliveryTypeToString,
    //    //        checkout_step: 4,
    //    //        checkout_option: 'Optional giftcard and coupon submitted',
    //    //        items: $scope.GetGACartItems()
    //    //    }).send();
    //    //} catch (e) {
    //    //    //speciaal voor Brave browser die er uit klapt.
    //    //}
    //}

    //$scope.proceedCycleScheme = function () {
    //    if ($scope.cyclescheme != undefined) {
    //        $scope.completeInProgress = true;
    //        $scope.cyclescheme.Valid = true;
    //        $scope.cyclescheme.Message = '';
    //        cartService.MasterDomain().then(function () {
    //            var url = cartService._masterDomain + '/' + $window.culture + '/shop/validatecyclescheme' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
    //            $http({
    //                method: 'POST',
    //                url: url,
    //                data: { number: $scope.cyclescheme.Number, code: $scope.cyclescheme.Code },
    //                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    //                transformRequest: function (obj) {
    //                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
    //                    var str = [];
    //                    for (var p in obj)
    //                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    //                    return str.join("&");
    //                },
    //                withCredentials: true
    //            }).then(function (res) {
    //                $scope.updateCart(function () {
    //                    /*$scope.actionButtonGiftcardOrCouponClicked = false;*/
    //                    $scope.completeInProgress = false;
    //                    if (res && res.data && res.data.Status == "success") {
    //                        $scope.cyclescheme.Certificate = res.data.Certificate;
    //                    } else {
    //                        $scope.cyclescheme.Valid = false;
    //                        $scope.cyclescheme.Message = res.data.Message;
    //                        angular.element('#CycleSchemeNumber').focus();
    //                    }
    //                }, 'ValidateCycleScheme');
    //            });
    //        });
    //    }
    //}

    //$scope.removeCycleScheme = function (item) {
    //    $scope.actionButtonCycleSchemeOrCouponClicked = true;
    //    $scope.completeInProgress = true;
    //    cartService.MasterDomain().then(function () {
    //        var url = cartService._masterDomain + '/' + $window.culture + '/shop/removecyclescheme' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
    //        $http({
    //            method: 'POST',
    //            url: url,
    //            withCredentials: true
    //        }).then(function (res) {
    //            $scope.updateCart(function () {
    //                $scope.actionButtonCycleSchemeOrCouponClicked = false;
    //                $scope.completeInProgress = false;
    //            }, 'RemoveCycleScheme');
    //        });
    //    });
    //}

    //$scope.proceedCycleSchemeOrCoupon = function () {
    //    $scope.errorCycleSchemeOrCoupon = '';
    //    $scope.proceedCycleSchemeOrCouponButtonClicked = true;

    //    $scope.isValidCycleSchemeOrCoupon = true;
    //    $('#collapsePayment').collapse('show');
    //    $('#collapseCycleSchemeOrCoupon').collapse('hide');
    //    $scope.proceedCycleSchemeOrCouponButtonClicked = false;

    //    try {
    //        $analytics.createBuilder().asCheckoutStep({
    //            step: 4,
    //            option: shippingOptionSelected.DeliveryTypeToString,
    //            checkout_step: 4,
    //            checkout_option: 'Optional CycleScheme and coupon submitted',
    //            items: $scope.GetGACartItems()
    //        }).send();
    //    } catch (e) {
    //        //speciaal voor Brave browser die er uit klapt.
    //    }
    //}

    $scope.fairstonePlans = [];
    $scope.fairstonePlansLoading = false;
    $scope.fairstonePlansError = '';
    $scope.fairstonePlanCode = null;

    $scope.loadFairstonePlans = function () {
        $scope.fairstonePlans = [];
        $scope.fairstonePlansError = '';
        $scope.fairstonePlansLoading = true;
        $scope.fairstonePlanCode = null;
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/fairstone-payment-plans' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                withCredentials: true
            }).then(function (res) {
                $scope.fairstonePlans = res.data || [];
                $scope.fairstonePlansLoading = false;
                if ($scope.fairstonePlans.length === 1) {
                    $scope.fairstonePlanCode = $scope.fairstonePlans[0].PlanValue;
                }
            }, function () {
                $scope.fairstonePlansLoading = false;
                $scope.fairstonePlansError = typeof lblFairstonePlansLoadFailed !== 'undefined' ? lblFairstonePlansLoadFailed : 'Could not load financing plans.';
            });
        });
    };

    $scope.selectPaymentOption = function (paymentOption) {
        $scope.proceedPaymentButtonClicked = false;
        if (paymentOption != undefined) {
            $scope.paymentoption = paymentOption;
        }
        if ($scope.paymentoption == 'v12') {
            $scope.initiateV12Slider();
        }
        if ($scope.paymentoption == 'klarnaPayLater') {
            $scope.initiateKlarna('pay_later');
        }
        if ($scope.paymentoption == 'klarnaOverTime') {
            $scope.initiateKlarna('pay_over_time');
        }
        if ($scope.paymentoption == 'simplefy') {
            $scope.initiateSimplefy();
        }
        if ($scope.paymentoption == 'stripeApplePay' || $scope.paymentoption == 'stripeGooglePay' || $scope.paymentoption == 'stripeGooglePayAndApplePay') {
            $scope.initiatestripeAppleGooglePay();
        }
        if ($scope.paymentoption == 'stripe3') {
            $scope.initiatestripe3();
        }
        if ($scope.paymentoption == 'afterpay') {
            $scope.initiateAfterpay();
        }
        if ($scope.paymentoption == 'paypalvenmo') {
            $scope.initiatePayPalCheckout('venmo');
        }
        if ($scope.paymentoption == 'mercadopago') {
            $scope.initiateMercadoPago();
        }
        if ($scope.paymentoption == 'stripeKlarna') {
            $scope.initiateStripeKlarna();
        }
        if ($scope.paymentoption == 'fairstone') {
            $scope.loadFairstonePlans();
        }
        //if ($scope.paymentoption == 'mercadopagocheckoutpro') {
        //    $scope.initiateMercadoPagoCheckoutPro();
        //}
    }

    $scope.proceedPayment = function (isMobile) {
        var billingAddressValid = false;
        $scope.errorPayment = '';
        $scope.proceedPaymentButtonClicked = true;
        if (($scope.checkTermsAndConditions == true && ($scope.checkPrivacy == true || $scope.checkPrivacy == null)) || isMobile) {
            if ($scope.paymentoption != null) {

                try {
                    trackEventGlobalAndLocalGA4({
                        'ga4_name': 'add_payment_info',
                        'ga4_currency': window.currencyCode,
                        'ga4_value': $scope.Cart.TotalIncludingShippingCosts,
                        'ga4_items': $scope.GetGACartItems(),
                        'ga4_payment_type': $scope.getPaymentOption($scope.paymentoption).Name
                    });
                    //$analytics.createBuilder().asPaymentSelectStep({
                    //    step: 5,
                    //    checkout_step: 5,
                    //    checkout_option: 'Proceed payment',
                    //    currency: window.currencyCode,
                    //    value: $scope.Cart.TotalIncludingShippingCosts,
                    //    items: $scope.GetGACartItems()
                    //}).send();
                } catch (e) {
                    //speciaal voor Brave browser die er uit klapt.
                }

                if ($scope.paymentoption == 'stripe2') {
                    if ($scope.formStripe2.$valid) {
                        //all required fields have been entered. Create token.
                        // The billing address needs to be validated and saved for USA & Canada => Append countries to _PaymentOption.cshtml as well
                        if (countryId == 1 || countryId == 10 || countryId == 16 || countryId == 43 || countryId == 19) {
                            cartService.MasterDomain().then(function () {
                                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setbillingaddress' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                                $http({
                                    method: 'POST',
                                    url: url,
                                    data: $('form[name="formOrder"]').serialize(),
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                    withCredentials: true
                                }).then(function (res) {
                                    if (res.data.result == true) {
                                        if (!isMobile) {
                                            _completeStripePayment2();
                                        } else {
                                            $scope.proceedPaymentButtonClicked = false;
                                            $('#collapseSummary').collapse('show');
                                            $('#collapsePayment').collapse('hide');
                                        }
                                    } else {
                                        $scope.errorPayment = res.data.error;
                                        $scope.proceedPaymentButtonClicked = false;
                                        $scope.completeInProgress = false;
                                    }
                                });
                            });
                        } else {
                            // Other countries don't have seperate fields for the billing address, we need to set the fields to the delivery address
                            $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                            $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                            $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                            $scope.creditcardAddress.city = $scope.Cart.Order.City;
                            $scope.creditcardAddress.state = $scope.Cart.Order.State;

                            if (!isMobile) {
                                _completeStripePayment2();
                            } else {
                                $scope.proceedPaymentButtonClicked = false;
                                $('#collapseSummary').collapse('show');
                                $('#collapsePayment').collapse('hide');
                            }
                        }
                    }
                    else {
                        if ($scope.formStripe2.$error.required != undefined && $scope.formStripe2.$error.required.length > 0) {
                            $scope.errorPayment = lblMakeSureAllRequiredFieldsAreEntered;
                        }
                    }
                }
                else if ($scope.paymentoption == 'stripe3') {
                    var stripe3FormValid = !$scope.formStripe3 || $scope.formStripe3.$valid;
                    if (stripe3FormValid) {
                        //all required fields have been entered. Create token.
                        // The billing address needs to be validated and saved for USA & Canada => Append countries to _PaymentOption.cshtml as well
                        if (countryId == 1 || countryId == 10 || countryId == 16 || countryId == 43 || countryId == 19) {
                            cartService.MasterDomain().then(function () {
                                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setbillingaddress' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                                $http({
                                    method: 'POST',
                                    url: url,
                                    data: $('form[name="formOrder"]').serialize(),
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                    withCredentials: true
                                }).then(function (res) {
                                    if (res.data.result == true) {
                                        if (!isMobile) {
                                            _completeStripePayment3();
                                        } else {
                                            $scope.proceedPaymentButtonClicked = false;
                                            $('#collapseSummary').collapse('show');
                                            $('#collapsePayment').collapse('hide');
                                        }
                                    } else {
                                        $scope.errorPayment = res.data.error;
                                        $scope.proceedPaymentButtonClicked = false;
                                        $scope.completeInProgress = false;
                                    }
                                });
                            });
                        } else {
                            // Other countries don't have seperate fields for the billing address, we need to set the fields to the delivery address
                            $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                            $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                            $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                            $scope.creditcardAddress.city = $scope.Cart.Order.City;
                            $scope.creditcardAddress.state = $scope.Cart.Order.State;

                            if (!isMobile) {
                                _completeStripePayment3();
                            } else {
                                $scope.proceedPaymentButtonClicked = false;
                                $('#collapseSummary').collapse('show');
                                $('#collapsePayment').collapse('hide');
                            }
                        }
                    }
                    else {
                        if ($scope.formStripe3 && $scope.formStripe3.$error.required != undefined && $scope.formStripe3.$error.required.length > 0) {
                            $scope.errorPayment = lblMakeSureAllRequiredFieldsAreEntered;
                        }
                    }
                }
                else if ($scope.paymentoption == 'v12') {
                    if ($scope.V12FinanceProduct.Selected != null && $scope.V12FinanceProduct.Selected > 0) {
                        $scope.isValidPayment = true;
                        $scope.isValidSummary = false;

                        if (!isMobile) {
                            $scope.SetV12Product(function () {
                                $scope.completeOrder(function () {
                                    $scope.isValidPayment = true;
                                    $scope.proceedPaymentButtonClicked = false;
                                });
                            });
                        } else {
                            $scope.SetV12Product(function () {
                                $scope.proceedPaymentButtonClicked = false;
                                $('#collapseSummary').collapse('show');
                                $('#collapsePayment').collapse('hide');
                            });
                        }
                    } else {
                        $scope.errorPayment = lblSelectFinanceOption;
                    }
                }
                else if ($scope.paymentoption == 'simplefy') {
                    if ($scope.formSimplefy.$valid && $scope.simplefyValid()) {
                        //all required fields have been entered. Create token.
                        // The billing address needs to be validated and saved for USA & Canada
                        if (countryId == 1 || countryId == 10 || countryId == 16) {
                            cartService.MasterDomain().then(function () {
                                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setbillingaddress' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                                $http({
                                    method: 'POST',
                                    url: url,
                                    data: $('form[name="formOrder"]').serialize(),
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                    withCredentials: true
                                }).then(function (res) {
                                    if (res.data.result == true) {
                                        if (!isMobile) {
                                            _completeSimplefyPayment();
                                        } else {
                                            $scope.proceedPaymentButtonClicked = false;
                                            $('#collapseSummary').collapse('show');
                                            $('#collapsePayment').collapse('hide');
                                        }
                                    } else {
                                        $scope.errorPayment = res.data.error;
                                        $scope.proceedPaymentButtonClicked = false;
                                    }
                                });
                            });
                        } else {
                            // Other countries don't have seperate fields for the billing address, we need to set the fields to the delivery address
                            $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                            $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                            $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                            $scope.creditcardAddress.city = $scope.Cart.Order.City;
                            $scope.creditcardAddress.state = $scope.Cart.Order.State;

                            if (!isMobile) {
                                _completeSimplefyPayment();
                            } else {
                                $scope.proceedPaymentButtonClicked = false;
                                $('#collapseSummary').collapse('show');
                                $('#collapsePayment').collapse('hide');
                            }
                        }
                    }
                    else {
                        if ($scope.formSimplefy.$error.required != undefined && $scope.formSimplefy.$error.required.length > 0) {
                            $scope.errorPayment = lblMakeSureAllRequiredFieldsAreEntered;
                        } else if (!$scope.simplefyValid()) {
                            $scope.errorPayment = lblInvalidCreditCardInformation;
                        }
                    }
                }
                else if ($scope.paymentoption == 'klarnaPayLater') {
                    if ($scope.KlarnaErrorMessage.length == 0) {
                        if (!isMobile) {
                            _completeKlarnaPayment('pay_later');
                        } else {
                            $scope.proceedPaymentButtonClicked = false;
                            $('#collapseSummary').collapse('show');
                            $('#collapsePayment').collapse('hide');
                        }
                    } else {
                        $scope.errorPayment = $scope.KlarnaErrorMessage;
                    }
                }
                else if ($scope.paymentoption == 'klarnaOverTime') {
                    if ($scope.KlarnaErrorMessage.length == 0) {
                        if (!isMobile) {
                            _completeKlarnaPayment('pay_over_time');
                        } else {
                            $scope.proceedPaymentButtonClicked = false;
                            $('#collapseSummary').collapse('show');
                            $('#collapsePayment').collapse('hide');
                        }
                    } else {
                        $scope.errorPayment = $scope.KlarnaErrorMessage;
                    }
                }
                else if ($scope.paymentoption == 'stripeApplePay' || $scope.paymentoption == 'stripeGooglePay' || $scope.paymentoption == 'stripeGooglePayAndApplePay') {
                    if (!isMobile) {
                        _completeStripeAppleOrGooglePay(null, $scope.paymentoption == 'stripeGooglePay' ? 'googlepay' : null);
                    } else {
                        //prButton.unmount('#payment-request-button');
                        //prButton.mount('#payment-request-button-mobile');
                        $scope.proceedPaymentButtonClicked = false;
                        $('#collapseSummary').collapse('show');
                        $('#collapsePayment').collapse('hide');
                    }
                }
                else if ($scope.paymentoption == 'stripeSofort') {
                    if (!isMobile) {
                        _completeStripeSofort();
                    } else {
                        $scope.proceedPaymentButtonClicked = false;
                        $('#collapseSummary').collapse('show');
                        $('#collapsePayment').collapse('hide');
                    }
                }
                else if ($scope.paymentoption == 'mercadopago') {
                    if (!isMobile) {
                        _completeMercadoPago();
                    } else {
                        $scope.proceedPaymentButtonClicked = false;
                        $('#collapseSummary').collapse('show');
                        $('#collapsePayment').collapse('hide');
                    }
                }
                else if ($scope.paymentoption == 'stripeKlarna') {
                    if (!isMobile) {
                        _completeStripeKlarna();
                    } else {
                        $scope.proceedPaymentButtonClicked = false;
                        $('#collapseSummary').collapse('show');
                        $('#collapsePayment').collapse('hide');
                    }
                }
                else if ($scope.paymentoption == 'fairstone') {
                    if (!$scope.fairstonePlanCode) {
                        $scope.errorPayment = lblSelectFairstonePlan;
                        $scope.proceedPaymentButtonClicked = false;
                    } else {
                        $scope.isValidPayment = true;
                        $scope.isValidSummary = false;
                        if (!isMobile) {
                            $scope.completeOrder(function () {
                                $scope.isValidPayment = true;
                                $scope.proceedPaymentButtonClicked = false;
                            });
                        } else {
                            $scope.proceedPaymentButtonClicked = false;
                            $('#collapseSummary').collapse('show');
                            $('#collapsePayment').collapse('hide');
                        }
                    }
                }
                else {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    if (!isMobile) {
                        $scope.completeOrder(function () {
                            $scope.isValidPayment = true;
                            $scope.proceedPaymentButtonClicked = false;
                        });
                    } else {
                        $scope.proceedPaymentButtonClicked = false;
                        $('#collapseSummary').collapse('show');
                        $('#collapsePayment').collapse('hide');
                    }
                }
            } else {
                $scope.errorPayment = lblSelectPaymentOption;

                // Focus on the first payment option
                if (document.getElementsByName('paymentoption') != null && document.getElementsByName('paymentoption').length > 0) {
                    document.getElementsByName('paymentoption')[0].focus();
                }
            }
        } else {
            $scope.errorPayment = lblPleaseAgreeToTermsAndConditions;

            // SK 13-10-2020
            angular.element('.terms-and-privacy input.ng-invalid').first().focus();
        }
    }

    var _completeStripePayment = function (isMobile) {
        Stripe.card.createToken({
            number: $scope.creditcardnumber,
            cvc: $scope.cvc,
            exp_month: $scope.creditcardmonth,
            exp_year: $scope.creditcardyear,
            address_zip: $scope.creditcardAddress.zipcode,
            name: $scope.creditcardAddress.name,
            address_line1: $scope.creditcardAddress.street
        }, function (status, response) {
            if (response.error) {
                $scope.errorPayment = response.error.message;
                $scope.$apply();
            } else {
                $scope.paymentKey = response.id;
                $scope.$apply();
                if (!isMobile) {
                    $scope.completeOrder(function () {
                        $scope.isValidPayment = true;
                        $scope.isValidSummary = false;
                        $scope.proceedPaymentButtonClicked = false;
                    });
                } else {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    $scope.proceedPaymentButtonClicked = false;
                    $scope.$apply();
                    $('#collapseSummary').collapse('show');
                    $('#collapsePayment').collapse('hide');
                }
            }
        });
    };

    var _completeStripePayment2 = function () {
        //var cardholderName = document.getElementById('Order.OrderBillingAddressName');
        //$scope.proceedSummaryButtonClicked = false;
        $scope.completeInProgress = true;
        logHandling("JS: e-commerce", "Stripe payment initiatie", $scope.Cart.Guid);
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/get-stripe-paymentintent?' + Math.random() + '&ga_clientId=' + $scope.GAclientId() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                if (res.data != null && res.data.success == true) {
                    stripe.handleCardPayment(
                        res.data.clientsecret, cardNumberElement, {
                        payment_method_data: {
                            billing_details: {
                                address: {
                                    city: $scope.creditcardAddress.city,
                                    //country: null,
                                    line1: $scope.creditcardAddress.street,
                                    postal_code: $scope.creditcardAddress.zipcode,
                                    state: $scope.creditcardAddress.state
                                },
                                email: $scope.Cart.Order.Email,
                                name: $scope.creditcardAddress.name
                            }
                        }
                    }
                    ).then(function (result) {
                        if (result.paymentIntent != null && result.paymentIntent.status == 'succeeded') {
                            logHandling("JS: e-commerce", "Stripe handleCardPayment SUCCESS, result: " + JSON.stringify(result), $scope.Cart.Guid);
                            // The payment has succeeded. Display a success message.
                            //if (IsInTestMode() == true) {
                            //Complete order directly
                            var url = cartService._masterDomain + '/' + $window.culture + '/shop/stripe-statechange';
                            $http({
                                method: 'GET',
                                url: url,
                                cache: false,
                                withCredentials: true
                            }).then(function (res) {
                                if (res.data.Success == true && res.data.RedirectUrl.length > 0) {
                                    if (res.data.RedirectMethod == 'Post') {
                                        $scope.PostForm(res.data.RedirectUrl, res.data.RedirectPostValues);
                                    } else {
                                        //redirect to V12 / CF
                                        window.location = res.data.RedirectUrl;
                                    }
                                } else {
                                    // Display error.message in your UI.
                                    $scope.errorPayment = res.data.Message != null && res.data.Message.length > 0 ? res.data.Message : 'Stripe error (unknown)';
                                    $scope.completeInProgress = false;
                                    $scope.$apply();
                                }
                            });
                            //} else {
                            //    $scope.completeOrder(function () {
                            //        $scope.isValidPayment = true;
                            //        $scope.isValidSummary = false;
                            //        $scope.proceedPaymentButtonClicked = false;
                            //    });
                            //}
                        } else {
                            logHandling("JS: e-commerce", "Stripe handleCardPayment FAILED, result: " + JSON.stringify(result), $scope.Cart.Guid);
                            var message = 'Stripe error (unknown)';
                            if (result.error != null) {
                                message = 'Stripe: ' + result.error.message + ' (' + result.error.code + ')';
                            }

                            //unlock cart to continue checkout
                            $scope.unlockCart(message);
                            // Display error.message in your UI.
                            $scope.errorPayment = result.error.message;
                            $scope.completeInProgress = false;
                            $scope.$apply();
                            exceptionHandling(message, 'CartGuid: ' + $scope.Cart.Guid);
                        }
                    });
                } else {
                    $timeout(function () {
                        var message = res.data.exception.Message != undefined ? res.data.exception.Message : res.data.exception;
                        $scope.unlockCart(message);
                        $scope.errorPayment = message;
                        $scope.proceedPaymentButtonClicked = false;
                        $scope.completeInProgress = false;
                        $scope.$apply();
                    });
                }
            })
        })
    };

    var _completeStripePayment3 = function () {
        $scope.completeInProgress = true;
        logHandling("JS: e-commerce", "Stripe payment initiatie", $scope.Cart.Guid);

        elements.submit().then(function (result) {
            if (result != null && result.error != null && result.error.message != null) {
                $scope.errorPayment = result.error.message;
                $scope.proceedPaymentButtonClicked = false;
                $scope.completeInProgress = false;
                $scope.$apply();
                logHandling("JS: e-commerce", "Stripe _completeStripePayment3 FAILED, result: " + JSON.stringify(result), $scope.Cart.Guid);
            } else {
                // Custom Payment Element methods (cpmt_…) are processed outside Stripe; confirmPayment is not supported for them.
                var selectedPm = result && result.selectedPaymentMethod;
                if (typeof selectedPm === 'string' && selectedPm.indexOf('cpmt_') === 0) {
                    logHandling("JS: e-commerce", "Stripe3 custom payment method handoff, cpmt: " + selectedPm, $scope.Cart.Guid);
                    cartService.MasterDomain().then(function () {
                        var handoffUrl = cartService._masterDomain + '/' + $window.culture + '/shop/stripe3-custom-payment-handoff/' + $scope.Cart.Order.Guid
                            + '?selectedCustomPaymentMethodTypeId=' + encodeURIComponent(selectedPm);
                        window.location = handoffUrl;
                    });
                    return;
                }
                cartService.MasterDomain().then(function () {
                    var url = cartService._masterDomain + '/' + $window.culture + '/shop/get-stripe-paymentintent?stripeversion=3&' + Math.random() + '&ga_clientId=' + $scope.GAclientId() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
                    $http({
                        method: 'GET',
                        url: url,
                        cache: false,
                        withCredentials: true
                    }).then(function (res) {
                        if (res.data != null && res.data.success == true) {
                            var clientSecret = res.data.clientsecret;
                            var stripe3ConfirmParams = {
                                return_url: window.masterDomain + '/' + $window.culture + '/shop/stripe-statechange-v2/' + $scope.Cart.Order.Guid
                            };
                            if (typeof window !== 'undefined' && window.stripe3PaymentElementBillingDetails != null && typeof window.stripe3PaymentElementBillingDetails === 'object') {
                                stripe3ConfirmParams.payment_method_data = {
                                    billing_details: window.stripe3PaymentElementBillingDetails
                                };
                            }
                            stripe.confirmPayment({
                                elements: elements,
                                clientSecret: clientSecret,
                                confirmParams: stripe3ConfirmParams
                            }).then(function (result) {
                                if (result.paymentIntent != null && result.paymentIntent.status == 'succeeded') {
                                    logHandling("JS: e-commerce", "Stripe handleCardPayment SUCCESS, result: " + JSON.stringify(result), $scope.Cart.Guid);
                                    // The payment has succeeded. Display a success message.
                                    //if (IsInTestMode() == true) {
                                    //Complete order directly
                                    var url = cartService._masterDomain + '/' + $window.culture + '/shop/stripe-statechange';
                                    $http({
                                        method: 'GET',
                                        url: url,
                                        cache: false,
                                        withCredentials: true
                                    }).then(function (res) {
                                        if (res.data.Success == true && res.data.RedirectUrl.length > 0) {
                                            if (res.data.RedirectMethod == 'Post') {
                                                $scope.PostForm(res.data.RedirectUrl, res.data.RedirectPostValues);
                                            } else {
                                                //redirect to V12 / CF
                                                window.location = res.data.RedirectUrl;
                                            }
                                        } else {
                                            // Display error.message in your UI.
                                            $scope.errorPayment = res.data.Message != null && res.data.Message.length > 0 ? res.data.Message : 'Stripe error (unknown)';
                                            $scope.completeInProgress = false;
                                            $scope.$apply();
                                        }
                                    });
                                    //} else {
                                    //    $scope.completeOrder(function () {
                                    //        $scope.isValidPayment = true;
                                    //        $scope.isValidSummary = false;
                                    //        $scope.proceedPaymentButtonClicked = false;
                                    //    });
                                    //}
                                } else {
                                    logHandling("JS: e-commerce", "Stripe handleCardPayment FAILED, result: " + JSON.stringify(result), $scope.Cart.Guid);
                                    var message = 'Stripe error (unknown)';
                                    if (result.error != null) {
                                        message = 'Stripe: ' + result.error.message + ' (' + result.error.code + ')';
                                    }

                                    //unlock cart to continue checkout
                                    $scope.unlockCart(message);
                                    // Display error.message in your UI.
                                    $scope.errorPayment = result.error.message;
                                    $scope.completeInProgress = false;
                                    $scope.$apply();
                                    exceptionHandling(message, 'CartGuid: ' + $scope.Cart.Guid);
                                }
                            });

                        } else {
                            $timeout(function () {
                                var message = res.data.exception.Message != undefined ? res.data.exception.Message : res.data.exception;
                                $scope.unlockCart(message);
                                $scope.errorPayment = message;
                                $scope.proceedPaymentButtonClicked = false;
                                $scope.completeInProgress = false;
                                $scope.$apply();
                            });
                        }
                    })
                })
            }
        });
        //if (submitError) {
        //    handleError(submitError);
        //    return;
        //}


    };

    $scope._completeStripeAppleOrGooglePay = function (callback, method) {
        $scope.completeInProgress = true;
        var paymentmethod = 'applepay=true';
        if (method != null && method == 'googlepay') {
            paymentmethod = 'googlepay=true';
        }
        logHandling("JS: e-commerce", "Stripe " + method + " payment initiatie", $scope.Cart.Guid);

        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/get-stripe-paymentintent?' + Math.random() + '&' + paymentmethod + '&ga_clientId=' + $scope.GAclientId() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                if (res.data != null && res.data.success == true) {
                    clientSecret = res.data.clientsecret;
                    if (callback) {
                        callback();
                    }
                } else {
                    $timeout(function () {
                        var message = res.data.exception.Message != undefined ? res.data.exception.Message : res.data.exception;
                        $scope.unlockCart(message);
                        $scope.errorPayment = message;
                        $scope.proceedPaymentButtonClicked = false;
                        $scope.completeInProgress = false;
                        $scope.$apply();
                    });
                }
            })
        })
    };

    var _completeStripeSofort = function () {
        $scope.completeInProgress = true;

        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/get-stripe-paymentintent?sofort=true&' + Math.random() + '&ga_clientId=' + $scope.GAclientId() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                if (res.data != null && res.data.success == true) {
                    stripe
                        .confirmSofortPayment(res.data.clientsecret, {
                            payment_method: {
                                sofort: {
                                    country: window.countryCode.toUpperCase()
                                },
                                billing_details: {
                                    name: $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname,
                                    email: $scope.Cart.Order.Email,
                                },
                            },
                            // Return URL where the customer should be redirected after the authorization.
                            return_url: window.masterDomain + '/' + $window.culture + '/shop/confirmation/' + $scope.Cart.Order.Guid,
                        })
                        .then(function (result) {
                            if (result.error) {
                                // Inform the customer that there was an error.
                                $timeout(function () {
                                    $scope.errorPayment = result.error.message;
                                    $scope.proceedPaymentButtonClicked = false;
                                    $scope.completeInProgress = false;
                                    $scope.$apply();
                                });
                            }
                        });
                } else {
                    $timeout(function () {
                        var message = res.data.exception.Message != undefined ? res.data.exception.Message : res.data.exception;
                        $scope.errorPayment = message;
                        $scope.proceedPaymentButtonClicked = false;
                        $scope.completeInProgress = false;
                        $scope.$apply();
                    });
                }
            })
        })
    };

    var _completeSimplefyPayment = function () {
        // Start the simplefy payment request. The code will continue in the callback of the CollectJS configure function (check initiateSimplefy function)
        CollectJS.startPaymentRequest();
    }

    var _completeMercadoPago = function () {
        $scope.completeInProgress = true;
        //var installments = await mp.getInstallments();
        window.createCardToken(function (token, formdata) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/mercadopago-pay' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: { token: token.id, installments: formdata.installments, paymentMethodId: formdata.paymentMethodId, issuerId: formdata.issuerId, formdata: jQuery.param(formdata) },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.result) {
                        window.location = '/' + $window.culture + '/shop/confirmation/' + res.data.guid + ($window.store != undefined && $window.store.length > 0 ? '/?store=' + $window.store : '/?cartguidvalidation=' + res.data.CartGuidValidation);
                    } else {
                        $timeout(function () {
                            var message = res.data.exception != null ? res.data.exception.Message != undefined ? res.data.exception.Message : res.data.exception : 'An error occured. Please try again';
                            $scope.errorPayment = message;
                            $scope.proceedPaymentButtonClicked = false;
                            $scope.completeInProgress = false;
                            $scope.$apply();
                        });
                    }
                });
            });
        });
    }

    var _completeStripeKlarna = function () {
        $scope.completeInProgress = true;
        stripe.confirmPayment({
            elements: elements,
            confirmParams: {
                return_url: window.location.origin + '/' + $window.culture + '/shop/stripe-statechange-v2/' + $scope.Cart.Order.Guid
            }
        }).then(function (result) {
            if (result.error) {
                $scope.errorPayment = result.error.message;
            }
            $scope.completeInProgress = false;
            // bij Klarna volgt normaal een redirect, dus hier kom je meestal niet
        }).catch(function (err) {
            $scope.errorPayment = err.message;
            $scope.completeInProgress = false;
            $scope.$apply();
        });
    }

    //var _completePayeezyPayment = function (isMobile) {
    //    $scope.errorPayment = '';
    //    //var $form = $scope.formPayeezy;
    //    var apiKey = document.getElementById("apikey").value;
    //    var js_security_key = document.getElementById("js_security_key").value;
    //    var auth = 'true';
    //    var ta_token = document.getElementById("ta_token").value;
    //    Payeezy.setApiKey(apiKey);
    //    Payeezy.setJs_Security_Key(js_security_key);
    //    Payeezy.setTa_token(ta_token);
    //    Payeezy.setAuth(auth);
    //    Payeezy.setCurrency('USD');
    //    Payeezy.createToken(function (status, response) {
    //        if (status != 201) {
    //            if (response.error && status != 400) {
    //                var error = response["error"];
    //                var errormsg = error["messages"];
    //                var errorcode = JSON.stringify(errormsg[0].code, null, 4);
    //                var errorMessages = JSON.stringify(errormsg[0].description, null, 4);
    //                $scope.errorPayment = errorMessages;
    //                $scope.$apply();
    //            }
    //            else {
    //                //if (status == 400 || status == 500) {
    //                var errorMessages = "";
    //                for (var i in response.Error.messages) {
    //                    errorMessages += response.Error.messages[i].description + ' ';
    //                }
    //                $scope.errorPayment = errorMessages;
    //                $scope.$apply();
    //            }

    //        } else {
    //            $scope.paymentKey = response.token.value;
    //            $scope.cardholderName = response.token.cardholder_name;
    //            $scope.expirationDate = response.token.exp_date;
    //            $scope.creditcardType = response.token.type;
    //            $scope.$apply();
    //            if (!isMobile) {
    //                $scope.completeOrder(function () {
    //                    $scope.isValidPayment = true;
    //                    $scope.isValidSummary = false;
    //                    $scope.proceedPaymentButtonClicked = false;
    //                });
    //            } else {
    //                $scope.isValidPayment = true;
    //                $scope.isValidSummary = false;
    //                $scope.proceedPaymentButtonClicked = false;
    //                $scope.$apply();
    //                $('#collapseSummary').collapse('show');
    //                $('#collapsePayment').collapse('hide');
    //            }
    //        }
    //    });
    //};

    var _completeKlarnaPayment = function (code) {
        Klarna.Payments.authorize({
            payment_method_category: code
        }, function (res) {
            if (res.approved) {
                $scope.klarnaAuthorizationToken = res.authorization_token;
                $scope.completeOrder(function () {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    $scope.proceedPaymentButtonClicked = false;
                });
            } else {
                $scope.unlockCart();
                $scope.proceedPaymentButtonClicked = false;
            }
        });
    }

    $scope.proceedSummary = function () {
        $scope.proceedSummaryButtonClicked = true;
        $scope.errorPayment = '';
        if ($scope.checkTermsAndConditions == true && ($scope.checkPrivacy == true || $scope.checkPrivacy == null)) {
            if ($scope.paymentoption == 'stripe2' && isMobile) {
                _completeStripePayment2(isMobile);
            } else if ($scope.paymentoption == 'stripe3' && isMobile) {
                _completeStripePayment3(isMobile);
            } else if ($scope.paymentoption == 'klarnaPayLater' && isMobile) {
                _completeKlarnaPayment('pay_later');
            } else if ($scope.paymentoption == 'klarnaOverTime' && isMobile) {
                _completeKlarnaPayment('pay_over_time');
            } else if ($scope.paymentoption == 'stripeApplePay' && isMobile) {
                _completeStripeAppleOrGooglePay();
            } else if ($scope.paymentoption == 'stripeGooglePay' && isMobile) {
                _completeStripeAppleOrGooglePay(null, 'googlepay');
            } else if ($scope.paymentoption == 'stripeGooglePayAndApplePay' && isMobile) {
                _completeStripeAppleOrGooglePay();
            } else if ($scope.paymentoption == 'stripeSofort' && isMobile) {
                _completeStripeSofort();
            } else if ($scope.paymentoption == 'mercadopago' && isMobile) {
                _completeMercadoPago();
            } else if ($scope.paymentoption == 'stripeKlarna' && isMobile) {
                _completeStripeKlarna();
            } else if ($scope.paymentoption == 'fairstone') {
                if (!$scope.fairstonePlanCode) {
                    $scope.errorPayment = lblSelectFairstonePlan;
                    $scope.proceedSummaryButtonClicked = false;
                } else {
                    $scope.completeOrder(function () {
                        $scope.isValidSummary = true;
                        $scope.isValidSummary = false;
                        $scope.proceedSummaryButtonClicked = false;
                    });
                }
            } else {
                $scope.completeOrder(function () {
                    $scope.isValidSummary = true;
                    $scope.isValidSummary = false;
                    $scope.proceedSummaryButtonClicked = false;
                });
            }

        } else {
            $scope.errorPayment = lblPleaseAgreeToTermsAndConditions;
        }
    }

    $scope.collapseIsValid = function (collapseName) {
        //Check of all required fields have been set
        switch (collapseName) {
            case 'contactinfo':
                return $scope.isValidContactInfo;
            case 'shippingoptions':
                return $scope.isValidShippingOption;
            case 'dealers':
                return $scope.isValidSelectedDealer;
            //case 'giftcardorcoupon':
            //    return $scope.isValidGiftcardOrCoupon;
            //case 'cycleschemeorcoupon':
            //    return $scope.isValidCycleSchemeOrCoupon;
            case 'payment':
                return $scope.isValidPayment;
            case 'summary':
                return $scope.isValidSummary;
            default:
                return false;
        }
    }

    $scope.collapseIsAuthorizedToEdit = function (collapseName) {
        //Check of this collapse block can be opened when previous collapse blocks are valid
        switch (collapseName) {
            case 'contactinfo':
                return true;
            case 'shippingoptions':
                return $scope.collapseIsValid('contactinfo');
            case 'dealers':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('shippingoptions');
            //case 'giftcardorcoupon':
            //    return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('shippingoptions') && $scope.collapseIsValid('dealers');
            //case 'cycleschemeorcoupon':
            //    return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('shippingoptions') && $scope.collapseIsValid('dealers');
            case 'payment':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('shippingoptions') && $scope.collapseIsValid('dealers');
            case 'summary':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('shippingoptions') && $scope.collapseIsValid('dealers') && $scope.collapseIsValid('payment');
            default:
                return false;
        }
    }

    $scope.expandCollapsePanel = function (collapseName) {
        window.scrollTo({ top: 0, behavior: "smooth" });

        if (!$scope.collapseIsAuthorizedToEdit(collapseName)) {
            return;
        }

        var panelIds = {
            contactinfo: 'collapseContactInfo',
            shippingoptions: 'collapseShippingOptions',
            dealers: 'collapseDealers',
            payment: 'collapsePayment',
            summary: 'collapseSummary'
        };

        var panelId = panelIds[collapseName];

        var $panel = angular.element('#' + panelId);
        if (!panelId || $panel.hasClass('in')) {
            return;
        }

        $('#accordion .panel-collapse.in').not('#' + panelId).collapse('hide');
        $panel.collapse('show');
    }

    $scope.SetV12Product = function (callbackSuccess) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/setv12product' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                data: { productId: $scope.V12FinanceProduct.Selected, deposit: $scope.V12FinanceProduct.DepositValue },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                withCredentials: true
            }).then(function (res) {
                if (res.data == true) {
                    if (callbackSuccess) {
                        callbackSuccess();
                    }
                }
            });
        });
    }

    $scope.completeOrder = function (callbackSuccess) {
        $scope.completeInProgress = true;

        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/completeorder' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            var cycleschemeNumber = "";
            var cycleSchemeCode = "";
            if ($scope.cyclescheme != null && $scope.cyclescheme.Number != undefined && $scope.cyclescheme.Number.length > 0 && $scope.cyclescheme.Code.length > 0) {
                cycleschemeNumber = $scope.cyclescheme.Number;
                cycleSchemeCode = $scope.cyclescheme.Code;
            }
            $http({
                method: 'POST',
                url: url,
                data: {
                    paymentoption: $scope.paymentoption,
                    paymentKey: $scope.paymentKey,
                    issuer: $scope.issuer,
                    employeeNumber: $scope.employeeNumber,
                    changeLocalStockToWarehouseStock: ($scope.OutOfStockValidation.OutOfStock == true && $scope.OutOfStockValidation.ContinueOrder == true),
                    cardholderName: $scope.cardholderName,
                    expirationDate: $scope.expirationDate,
                    last4Digits: $scope.last4Digits,
                    creditcardType: $scope.creditcardType,
                    ga_clientId: $scope.GAclientId(),
                    klarnaAuthorizationToken: $scope.klarnaAuthorizationToken,
                    cycleSchemeNumber: cycleschemeNumber,
                    cycleSchemeCode: cycleSchemeCode,
                    warningShown: $scope.IsWarning,
                    fairstonePlanCode: $scope.fairstonePlanCode || ''
                },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                withCredentials: true
            }).then(function (res) {
                if (res.data.Result == true) {
                    //payment successfully.
                    //try {
                    //    $analytics.createBuilder().asCheckoutStep({
                    //        step: 6,
                    //        option: $scope.paymentoption,
                    //        checkout_step: 6,
                    //        checkout_option: 'Complete payment',
                    //        items: $scope.GetGACartItems()
                    //    }).send();
                    //} catch (e) {
                    //    //speciaal voor Brave browser die er uit klapt.
                    //}

                    // Bakkie 12/08/2022: Turned off AddPaymentInfo as requested by Chris Degenaars in 
                    // his e-mail on 22/07/2022
                    ////post to Facebook
                    //try {
                    //    var preferences = $.gdprcookie.preference();
                    //    if (preferences.indexOf('marketing') > -1) {
                    //        fbq('track', 'AddPaymentInfo', {
                    //            value: $scope.Cart.TotalIncludingShippingCosts,
                    //            currency: window.currencyCode
                    //        });
                    //    }
                    //} catch (e) {
                    //}

                    $scope.OrderConfirmation = res.data;
                    $scope.OutOfStockValidation = res.data.OutOfStockValidation;

                    if (callbackSuccess && $scope.paymentoption != 'paypal') {
                        callbackSuccess();
                    }

                    if (res.data.RedirectUrl != null && res.data.RedirectUrl.length > 0) {
                        if (res.data.RedirectMethod == 'POST') {
                            $scope.PostForm(res.data.RedirectUrl, res.data.RedirectPostValues);
                        } else {
                            //redirect to V12 / CF
                            window.location = res.data.RedirectUrl;
                        }
                    } else if ($scope.paymentoption == 'affirm') {
                        //redirect to affirm
                        $scope.initiateAffirm();
                    }
                    //else if ($scope.paymentoption == 'paypal') {
                    //    //redirect to paypal
                    //    $scope.initiatePayPal(res.data.Guid);
                    //}
                    else if ($scope.paymentoption == 'verifone') {
                        //redirect to paypal
                        $scope.initiateVerifone(res.data.Guid);
                    }
                    else if ($scope.paymentoption == 'paybright') {
                        //redirect to paybright
                        $scope.initiatePayBright(res.data.Guid);
                    }
                    else if ($scope.paymentoption == 'sella') {
                        //redirect to sella
                        $scope.initiateSella(res.data.Guid);
                    }
                    else if ($scope.paymentoption == 'inicis') {
                        //redirect to paybright
                        $scope.initiateInicis(res.data.Guid);
                    }
                    //else if ($scope.paymentoption == 'toss') {
                    //    //redirect to paybright
                    //    $scope.initiateToss(res.data.Guid);
                    //}
                    else {
                        //Redirect to confirmationpage
                        window.location = '/' + $window.culture + '/shop/confirmation/' + res.data.Guid + ($window.store != undefined && $window.store.length > 0 ? '/?store=' + $window.store : '/?cartguidvalidation=' + res.data.CartGuidValidation);
                    }

                } else {
                    //something went wrong
                    $scope.errorPayment = res.data.ExceptionMessage;
                    $scope.completeInProgress = '';
                    $scope.IsWarning = res.data.IsWarning;
                }
            });
        });
    }

    $scope.initiateSimplefy = function () {
        // Call configure function to redraw the iFrames and to register the callback function.
        CollectJS.configure({
            "timeoutDuration": 10000,
            "timeoutCallback": function () {
                $scope.errorPayment = lblCreditCardTimeout;
                $scope.$apply();
            },
            "callback": function (response) {
                if (response && response.card) {
                    if (response.card.number) {
                        // Get the last 4 digits
                        var startAt = response.card.number.length - 4;
                        $scope.last4Digits = response.card.number.substr(startAt, 4);
                    }

                    if (response.card.exp) {
                        $scope.expirationDate = response.card.exp;
                    }
                }

                $scope.paymentKey = response.token;
                $scope.$apply();
                if (!$scope.IsMobile()) {
                    $scope.completeOrder(function () {
                        $scope.isValidPayment = true;
                        $scope.isValidSummary = false;
                        $scope.proceedPaymentButtonClicked = false;
                    });
                } else {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    $scope.proceedPaymentButtonClicked = false;
                    $scope.$apply();
                    $('#collapseSummary').collapse('show');
                    $('#collapsePayment').collapse('hide');
                }
            },
            "validationCallback": function (field, status, message) {
                log(message);

                switch (field) {
                    case 'ccnumber':
                        $scope.simplefyCCNumberValid = status;
                        break;
                    case 'cvv':
                        $scope.simplefyCVVCodeValid = status;
                        break;
                    case 'ccexp':
                        $scope.simplefyExpValid = status;
                        break;
                    default:
                        console.warn('Simplefy field ' + field + ' is unknown');
                }
            }
        });
    }

    $scope.initiateAffirm = function () {
        if ($scope.Cart.AffirmExtraData != null) {
            $window.affirm.checkout({
                "config": {
                    "financial_product_key": ($scope.countryId == 10 ? "KGCVUVW288IZHHXN" : divisionCode == '600' ? "5TR9Z5CAL20TY8HQ" : "M4MI78P3LSG07I94")
                },

                "financing_program": $scope.Cart.AffirmExtraData.FinancingProgram,

                "merchant": {
                    "user_cancel_url": $scope.Cart.AffirmExtraData.CancelUrl,
                    "user_confirmation_url": $scope.Cart.AffirmExtraData.ConfirmationUrl,
                    "user_confirmation_url_action": "POST",
                },

                "items": $scope.Cart.AffirmExtraData.CartItems,
                "order_id": $scope.OrderConfirmation.OrderId,
                "metadata": {
                    "shipping_type": $scope.OrderConfirmation.ShippingGuid
                },
                "shipping": {
                    "name": {
                        "first": $scope.Cart.Order.Firstname,
                        "last": $scope.Cart.Order.Lastname
                    },
                    "address": {
                        "line1": $scope.Cart.Order.Street,
                        "line2": "",
                        "city": $scope.Cart.Order.City,
                        "state": $scope.Cart.Order.State,
                        "zipcode": $scope.Cart.Order.Postalcode
                    },
                    "phone_number": $scope.Cart.Order.Phone,
                    "email": $scope.Cart.Order.Email
                },
                "billing": {
                    "name": {
                        "first": $scope.Cart.Order.Firstname,
                        "last": $scope.Cart.Order.Lastname
                    },
                    "address": {
                        "line1": $scope.Cart.Order.Street,
                        "line2": "",
                        "city": $scope.Cart.Order.City,
                        "state": $scope.Cart.Order.State,
                        "zipcode": $scope.Cart.Order.Postalcode
                    },
                    "phone_number": $scope.Cart.Order.Phone,
                    "email": $scope.Cart.Order.Email,
                },
                "shipping_amount": Math.round($scope.OrderConfirmation.ShippingCosts * 100),
                "tax_amount": Math.round($scope.OrderConfirmation.Tax * 100),
                "total": Math.round($scope.OrderConfirmation.Total * 100),
                "currency": $scope.countryId == 10 ? "CAD" : "USD"
            });
            $window.affirm.checkout.post();
            $scope.completeInProgress = '';
        }
    }

    $scope.V12Slider = {
        //value: function () {
        //    return $scope.Cart.TotalIncludingShippingCosts * 0.1;
        //},
        options: {
            step: 1,
            translate: function (value) {
                return '£' + value;
            },
            showSelectionBar: true,
            getSelectionBarColor: function (value) {
                return '#0DB9F0';
            }
        }
    };

    $scope.initiateV12Slider = function (price) {
        $timeout(function () {
            if (price == undefined || price.length == 0) {
                price = $scope.Cart.TotalIncludingShippingCosts;
            }
            if ($scope.Cart == undefined || $scope.Cart.V12FinanceProducts == undefined) {
                $scope.Cart.V12FinanceProducts = $scope.v12FinanceProducts;
                $scope.Cart.TotalIncludingShippingCosts = $scope.partnumbers[0].price;
            }

            $scope.$broadcast('rzSliderForceRender');
            //$scope.V12FinanceProduct.DepositValue = Math.round(price * 0.1);
            //$scope.V12Slider.options.ceil = Math.round(price * 0.5) - 1;
            ////min loan amount = 1000. Change ceil when ceil amount is > then min loan amount
            //if ((price - 1000) < $scope.V12Slider.options.ceil) {
            //    $scope.V12Slider.options.ceil = Math.round(price - 1000);
            //}
            //$scope.V12Slider.options.floor = Math.round(price * 0.1);
            //$scope.V12Slider.options.minLimit = Math.round(price * 0.1);
            //$scope.V12Slider.value = Math.round(price * 0.1);

            $scope.V12FinanceProduct.Selected = $scope.Cart.V12FinanceProducts[0].ProductId;
        });
    }

    //$scope.initiatePayPal = function (guid) {
    //    cartService.MasterDomain().then(function () {
    //        var url = cartService._masterDomain + '/' + $window.culture + '/shop/paypalinitiate/' + guid + '?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
    //        $http({
    //            method: 'GET',
    //            url: url,
    //            cache: false,
    //            withCredentials: true
    //        }).then(function (res) {
    //            $('body').append(res.data);
    //            $('form#paypal').submit();
    //        });
    //    });
    //}

    $scope.initiateVerifone = function (guid) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/verifoneinitiate/' + guid + '?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $('body').append(res.data);
                $('form#verifone').submit();
            });
        });
    }

    $scope.initiateKlarna = function (code) {
        $scope.KlarnaErrorMessage = '';
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/klarna-initiate?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                try {
                    if (res.data.key != null) {
                        Klarna.Payments.init({
                            client_token: res.data.key
                        });
                        Klarna.Payments.load({
                            container: '#klarna-payments-container-' + code,
                            payment_method_category: code
                        }, function (res) {
                            console.debug(res);
                            if (res.show_form == false) {
                                $scope.KlarnaErrorMessage = 'This payment option is not available';
                            }
                        });
                    } else {
                        $scope.KlarnaErrorMessage = res.data.error;
                    }
                } catch (e) {
                    // Handle error.
                }
            });
        });
    }

    $scope.initiatePayBright = function (guid) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/paybrightinitiate/' + guid + '?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $('body').append(res.data);
                $('form#paybright').submit();
            });
        });
    }

    $scope.initiateSella = function (guid) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/sellainitiate/' + guid + '?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $('body').append(res.data);
                $('form#sella').submit();
            });
        });
    }

    $scope.initiateInicis = function (guid) {
        cartService.MasterDomain().then(function () {
            var ismobile = isMobile();
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/inicisinitiate/' + guid + '?isMobile=' + ismobile + '&r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $('body').append(res.data);
                if (isMobile()) {
                    myform = document.formInicis;
                    myform.action = "https://mobile.inicis.com/smart/payment/";
                    myform.target = "_self";
                    myform.submit();
                } else {
                    INIStdPay.pay('form-inicis');
                }
            });
        });
    }

    //$scope.initiateToss = function (guid) {
    //    const clientKey = "test_ck_Kma60RZblrqbjn0XzYZ8wzYWBn14"
    //    const customerKey = "FWfwRIN-jP0xtJE0vwVsw" // 내 상점에서 고객을 구분하기 위해 발급한 고객의 고유 ID

    //    const button = document.getElementById("btnConfirm")

    //    // ------  결제위젯 초기화 ------ 
    //    // 비회원 결제에는 customerKey 대신 ANONYMOUS를 사용하세요.
    //    const paymentWidget = PaymentWidget(clientKey, PaymentWidget.ANONYMOUS) // 회원 결제
    //    // const paymentWidget = PaymentWidget(clientKey, PaymentWidget.ANONYMOUS) // 비회원 결제

    //    // ------  결제위젯 렌더링 ------ 
    //    // 결제수단 UI를 렌더링할 위치를 지정합니다. `#payment-method`와 같은 CSS 선택자와 결제 금액 객체를 추가하세요.
    //    // https://docs.tosspayments.com/reference/widget-sdk#renderpaymentmethods선택자-결제-금액-옵션
    //    paymentWidget.renderPaymentMethods("#payment-method", { value: $scope.Cart.TotalIncludingShippingCosts })

    //    // ------  이용약관 렌더링 ------
    //    // 이용약관 UI를 렌더링할 위치를 지정합니다. `#agreement`와 같은 CSS 선택자를 추가하세요.
    //    // https://docs.tosspayments.com/reference/widget-sdk#renderagreement선택자
    //    paymentWidget.renderAgreement('#agreement')

    //    // ------ '결제하기' 버튼 누르면 결제창 띄우기 ------
    //    // 더 많은 결제 정보 파라미터는 결제위젯 SDK에서 확인하세요.
    //    // https://docs.tosspayments.com/reference/widget-sdk#requestpayment결제-정보
    //    paymentWidget.requestPayment({
    //        orderId: $scope.Cart.Order.OrderNumber,            // 주문 ID(직접 만들어주세요)
    //        orderName: $scope.Cart.NumberOfCartItems + ' ' + window.divisionFullName + ' ' + window.labelItems,                 // 주문명
    //        successUrl: window.masterDomain + '/' + window.culture + '/shop/tossstatechange/' + $scope.Cart.Order.OrderGuid,  // 결제에 성공하면 이동하는 페이지(직접 만들어주세요)
    //        failUrl: window.masterDomain + '/' + window.culture + '/shop/cancel-payment?guid=' + $scope.Cart.Order.OrderGuid,        // 결제에 실패하면 이동하는 페이지(직접 만들어주세요)
    //        customerEmail: $scope.Cart.Order.Email,
    //        customerName: $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname
    //    });
    //}

    $scope.initiatestripeAppleGooglePay = function () {
        //paymentRequest._initialOptions.total.amount = $scope.Cart.TotalIncludingShippingCosts * 100;
        paymentRequest.update({
            total: {
                label: paymentRequest._initialOptions.total.label,
                amount: Math.round($scope.Cart.TotalIncludingShippingCosts * 100),
            }
        });
        logHandling("JS: e-commerce", "initiatestripeAppleGooglePay. PaymentRequest.update. Label: " + paymentRequest._initialOptions.total.label + ", amount: " + $scope.Cart.TotalIncludingShippingCosts * 100, $scope.Cart.Guid);


        // Check the availability of the Payment Request API first.
        //paymentRequest.canMakePayment().then(function (result) {
        //    log('ApplePay/GooglePay canMakePayment: ' + JSON.stringify(result));
        //    if (result && (result.applePay == true || result.googlePay == true)) {
        //        prButton.mount('#payment-request-button');
        //    } else {
        //        $('#payment-request-button').html('This payment is not possible: ' + result);
        //    }
        //});
    }

    $scope.initiatestripe3 = function () {
        elements.update({ amount: Math.round($scope.Cart.TotalIncludingShippingCosts * 100) });
        logHandling("JS: e-commerce", "initiatestripe3. PaymentRequest.update, amount: " + $scope.Cart.TotalIncludingShippingCosts * 100, $scope.Cart.Guid);
    }

    $scope.initiateStripeKlarna = function () {
        logHandling("JS: e-commerce", "Stripe Klarna payment initiatie", $scope.Cart.Guid);
        $scope.completeInProgress = true;
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/get-stripe-paymentintent?stripeklarna=true&' + Math.random() + '&ga_clientId=' + $scope.GAclientId() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                if (res.data != null && res.data.success == true) {
                    var clientSecret = res.data.clientsecret;
                    window.clientSecret = clientSecret;

                    var elements = stripe.elements({
                        clientSecret: clientSecret
                    });
                    window.elements = elements;

                    // 2. Initialiseer Elements
                    var paymentElement = window.elements.create("payment");
                    paymentElement.mount("#payment-element-klarna");

                    $scope.completeInProgress = false;
                } else {
                    $timeout(function () {
                        var message = res.data.exception.Message != undefined ? res.data.exception.Message : res.data.exception;
                        $scope.errorPayment = message;
                        $scope.completeInProgress = false;
                        $scope.$apply();
                    });
                }
            })
        })



    }

    $scope.initiateAfterpay = function () {
        $('#afterpay-widget-container').empty();
        window.afterpayWidget = new AfterPay.Widgets.PaymentSchedule({
            amount: { amount: $scope.Cart.TotalIncludingShippingCosts.toString(), currency: window.currencyCode },
            target: '#afterpay-widget-container',
            locale: window.cultureFull,
            style: {
                border: true,
                heading: true,
                logo: false,
            },
            onReady: function (event) {
                // Fires when the widget is ready to accept updates.
                // An initial call to "update" must be made here.
                //afterpayWidget.update({
                //    amount: { amount: "123.45", currency: "USD" },
                //})
            },
            onChange: function (event) {
                // Fires after each update and on any other state changes.
                // See "Getting the widget's state" for more details.
            },
            onError: function (event) {
                // See "Handling widget errors" for more details.
            },
        });
    }

    $scope.initiatePayPalCheckout = function (paymentmethod) {
        if ($('#paypal-button-container' + (isMobile() ? '-mobile' : '')).html().length == 0) {
            paypal.getFundingSources().forEach(function (fundingSource) {
                // Initialize the buttons
                var button = paypal.Buttons({
                    fundingSource: fundingSource,
                    createOrder: function () {
                        $scope.proceedSummaryButtonClicked = true;
                        $scope.errorPayment = '';
                        if ($scope.checkTermsAndConditions == true && ($scope.checkPrivacy == true || $scope.checkPrivacy == null)) {

                            return fetch('/' + $window.culture + '/shop/create-paypal-checkout-order', {
                                method: "post",
                                body: JSON.stringify({
                                    ga_clientId: $scope.GAclientId()
                                })
                            })
                                .then(function (response) {
                                    //log(response.json());
                                    return response.json();
                                })
                                .then(function (order) {
                                    //log(order);
                                    return order.key;
                                });
                        } else {
                            $scope.errorPayment = lblPleaseAgreeToTermsAndConditions;
                            angular.element('.terms-and-privacy input.ng-invalid').first().focus();
                        }
                    },
                    // Finalize the transaction on the server after payer approval
                    onApprove: function (data) {
                        return fetch('/' + $window.culture + '/shop/capture-paypal-checkout-order', {
                            method: "post",
                        })
                            .then(function (response) {
                                //log(response.json());
                                response.json();
                            })
                            .then(function (orderData) {
                                if (orderData.result == true) {
                                    //redirect to confirmation page
                                    window.location = '/' + $window.culture + '/shop/confirmation/' + orderData.guid;
                                } else {
                                    $scope.errorPayment = orderData.message;
                                }
                            });
                    }
                })
                // Check if the button is eligible
                if (button.isEligible() && (paymentmethod == null || fundingSource == paymentmethod)) {
                    // Render the standalone button for that funding source
                    button.render('#paypal-button-container' + (isMobile() ? '-mobile' : ''));
                } else if (window.inTestMode != undefined && window.inTestMode == true) {
                    button.render('#paypal-button-container' + (isMobile() ? '-mobile' : ''));
                }
            })
        }
    }

    $scope.initiateMercadoPago = function () {
        window.cardForm = mp.cardForm({
            amount: $scope.Cart.TotalIncludingShippingCosts + '',
            iframe: true,
            form: {
                id: "checkoutForm",
                cardNumber: {
                    id: "form-checkout__cardNumber",
                    placeholder: "",
                },
                expirationDate: {
                    id: "form-checkout__expirationDate",
                    placeholder: "",
                },
                securityCode: {
                    id: "form-checkout__securityCode",
                    placeholder: "",
                },
                cardholderName: {
                    id: "form-checkout__cardholderName",
                    placeholder: "",
                },
                issuer: {
                    id: "form-checkout__issuer",
                    placeholder: "",
                },
                installments: {
                    id: "form-checkout__installments",
                    placeholder: "",
                }
            },
            callbacks: {
                //onFormMounted: error => {
                //    if (error) return console.warn("Form Mounted handling error: ", error);
                //    console.log("Form mounted");
                //},
                onFormMounted: function (error) {
                    if (error) return console.warn("Form Mounted handling error: ", error);
                    console.log("Form mounted");
                },
                onFetching: function (resource) {
                    log("Fetching resource: ", resource);

                    // Animate progress bar
                    const progressBar = document.querySelector(".progress-bar");
                    progressBar.removeAttribute("value");

                    if (resource == 'installments') {
                        log('MercadoPago Issuer: ' + $('#form-checkout__issuer').val());
                        setTimeout(function () {
                            if ($('#form-checkout__installments option').length > 1) {
                                $scope.mercadopageShowInstallments = true;
                                $scope.$apply();
                            } else {
                                $scope.mercadopageShowInstallments = false;
                                $scope.$apply();
                            }
                        }, 500)
                    }

                    return function () {
                        progressBar.setAttribute("value", "0");
                    };
                }
            },
        });

        try {
            const cardNumberElement = mp.fields.create('cardNumber', {
                placeholder: "Card Number"
            }).mount('form-checkout__cardNumber');
            const expirationDateElement = mp.fields.create('expirationDate', {
                placeholder: "MM/YY",
            }).mount('form-checkout__expirationDate');
            const securityCodeElement = mp.fields.create('securityCode', {
                placeholder: "Security Code"
            }).mount('form-checkout__securityCode');
        } catch (e) {

        }
    }

    //$scope.initiateMercadoPagoCheckoutPro = function () {
    //    cartService.MasterDomain().then(function () {
    //        var url = cartService._masterDomain + '/' + $window.culture + '/shop/mercadopagocheckoutpro-initiate' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
    //        $http({
    //            method: 'POST',
    //            url: url,
    //            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    //            transformRequest: function (obj) {
    //                //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
    //                var str = [];
    //                for (var p in obj)
    //                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    //                return str.join("&");
    //            },
    //            withCredentials: true
    //        }).then(function (res) {
    //            const bricksBuilder = mp.bricks();

    //            mp.bricks().create("wallet", "wallet_container", {
    //                initialization: {
    //                    preferenceId: res.data.id,
    //                },
    //                customization: {
    //                    texts: {
    //                        valueProp: 'smart_option',
    //                    },
    //                },
    //            });
    //        });
    //    });

    //}

    //TODO: Implement Enhanced E-Commerce Tracking for Coupon Codes
    $scope.proceedCoupon = function () {
        if ($scope.coupon != null && $scope.coupon.Code.length > 0) {
            //$scope.actionButtonGiftcardOrCouponClicked = true;
            $scope.completeInProgress = true;
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/validatecoupon' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: { coupon: $scope.coupon.Code },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    $scope.updateCart(function () {
                        if ($scope.coupon == undefined || $scope.coupon.length == 0 || res.data.Valid == false) {
                            $scope.coupon = res.data;
                        }

                        if ($scope.coupon.Code.toLowerCase() == 'undefined') {
                            $scope.coupon.Code = '';
                        }

                        //get dealers again when coupon is related to dealers
                        if ($scope.coupon.DealerCodes != null && $scope.coupon.DealerCodes.length > 0) {
                            $scope.getGeolocationAndGetDealers();
                        }

                        if ($scope.coupon.Valid == false) {
                            angular.element('#CouponCode').focus();
                        }
                        //$scope.actionButtonGiftcardOrCouponClicked = false;
                        $scope.completeInProgress = false;
                    }, 'ValidateCoupon');
                });
            });
        }
    }

    $scope.removeCoupon = function () {
        //$scope.actionButtonGiftcardOrCouponClicked = true;
        $scope.completeInProgress = true;
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/removecoupon' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                withCredentials: true
            }).then(function (res) {
                $scope.updateCart(function () {
                    //get dealers again when coupon is related to dealers
                    if ($scope.coupon.DealerCodes != null && $scope.coupon.DealerCodes.length > 0) {
                        $scope.getGeolocationAndGetDealers();
                    }

                    $scope.coupon = null;
                    //$scope.actionButtonGiftcardOrCouponClicked = false;
                    $scope.completeInProgress = false;
                }, 'RemoveCoupon');
            });
        });
    }

    $scope.unlockCart = function (message) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/unlock-cart' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                withCredentials: true,
                data: { message: message }
            });
        });
    }

    $scope.initPartnumbers = function (id, productTypeId, useGlobalCatalogue) {

        $http({
            method: 'GET',
            url: '/' + $window.culture + '/shop/productselector/' + id + '/' + productTypeId + '/' + useGlobalCatalogue.toLowerCase()
        }).then(function (res) {
            $scope.partnumbers = res.data.Partnumbers;
            $scope.partnumbersWithUsage = res.data.Partnumbers.filter(function (partnumber) {
                if (partnumber.hasUsage) {
                    return partnumber;
                }
            });
            $scope.product = res.data.Product;

            $scope.santanderFinanceLabel = res.data.SantanderFinanceLabel;
            $scope.sofincoFinanceLabel = res.data.SofincoFinanceLabel;
            $scope.AlphacreditLabel = res.data.AlphacreditLabel;
            $scope.v12FinanceProducts = res.data.V12FinanceProducts;
            $scope.v12Label = res.data.V12Label;
            $scope.consorsFinanzLabel = res.data.ConsorsFinanzLabel;
            $scope.colors = res.data.Colors;
            $scope.colorCodes = res.data.ColorCodes;
            $scope.priceDifferences = res.data.PriceDifferences;
            $scope.hasVariations = res.data.HasVariations;
            $scope.useLocalStockGear = res.data.UseLocalStockGear;
            $scope.productAwardLocalized = res.data.ProductAwardLocalized;
            $scope.productAwardsLocalized = res.data.ProductAwardsLocalized;

            //remove gallery images
            if ($scope.product.CloudinaryImagesToPartnumbers != null) {
                var tempImages = [];
                for (var i = 0; i < $scope.product.CloudinaryImagesToPartnumbers.length; i++) {
                    if ($scope.product.CloudinaryImagesToPartnumbers[i].CloudinaryImage.IsGalleryImage == false) {
                        tempImages.push($scope.product.CloudinaryImagesToPartnumbers[i]);
                    }
                }
                $scope.product.CloudinaryImagesToPartnumbers = tempImages;
            }

            if ($scope.colors.length > 0) {
                if ($scope.product.CloudinaryImagesToPartnumbers != null && $scope.product.CloudinaryImagesToPartnumbers.length > 0 && $scope.product.CloudinaryImagesToPartnumbers[0].Color != null) {
                    $scope.color = $scope.product.CloudinaryImagesToPartnumbers[0].Color;
                } else {
                    $scope.color = $scope.colors[0];
                }
            } else {
                $scope.color = "one-color"
            }

            setTimeout(function () {
                angular.element('#colorSelect .selectpicker').selectpicker('refresh');
                angular.element('#partnumberSelect .selectpicker').selectpicker('refresh');
            });

            //set default size + color when partnumbercode is located in querystring. Necessary for google feed.
            if (getParameterByName('partnumber') != null && getParameterByName('partnumber').length > 0) {
                $scope.partnumberCode = getParameterByName('partnumber');
                $scope.selectPartnumber();
                if ($scope.partnumber.color != null && $scope.partnumber.color.length > 0) {
                    $scope.color = $scope.partnumber.color;
                }
                $scope.selectColor2();
                $scope.partnumberCode = getParameterByName('partnumber');
                $scope.selectPartnumber();
            } else if ($scope.product.CloudinaryImagesToPartnumbers != null) {
                $scope.selectColor2($scope.product.CloudinaryImagesToPartnumbers[0]);
            } else {
                $scope.selectColor2();
            }
        });
    }

    $scope.initImages = function (id, productTypeId, useGlobalCatalogue) {
        $http({
            method: 'GET',
            url: '/' + $window.culture + '/shop/productselector/' + id + '/' + productTypeId + '/' + useGlobalCatalogue.toLowerCase()
        }).then(function (res) {
            $scope.product = res.data.Product;

            if ($scope.product.CloudinaryImagesToPartnumbers != undefined && $scope.product.CloudinaryImagesToPartnumbers.length > 0) {
                //remove gallery images
                var tempImages = [];
                for (var i = 0; i < $scope.product.CloudinaryImagesToPartnumbers.length; i++) {
                    if ($scope.product.CloudinaryImagesToPartnumbers[i].CloudinaryImage.IsGalleryImage == false) {
                        tempImages.push($scope.product.CloudinaryImagesToPartnumbers[i]);
                    }
                }
                $scope.product.CloudinaryImagesToPartnumbers = tempImages;

                // get first image
                var cloudinaryImage = $scope.product.CloudinaryImagesToPartnumbers[0];
                $scope.activeImageMain = cloudinaryImage.CloudinaryImage.ImageUrlMain;
                $scope.activeImageLarge = $scope.product.EnableImageByTransformation ? cloudinaryImage.CloudinaryImage.ImageUrlLargeByTransformation : cloudinaryImage.CloudinaryImage.ImageUrlLarge;
                $scope.activeImageSmall = cloudinaryImage.CloudinaryImage.ImageUrlSmall;
                $scope.activeImageThumb = $scope.product.EnableImageByTransformation ? cloudinaryImage.CloudinaryImage.ImageUrlThumbByTransformation : cloudinaryImage.CloudinaryImage.ImageUrlThumb;
                $scope.activeImageZoom = $scope.product.EnableImageByTransformation ? cloudinaryImage.CloudinaryImage.ImageUrlMegaZoomByTransformation : cloudinaryImage.CloudinaryImage.ImageUrlMegaZoom;
                // index
                $scope.activeImageIndex = $scope.product.CloudinaryImagesToPartnumbers.indexOf(cloudinaryImage);
                // alt text
                $scope.activeImageAltText = cloudinaryImage.CloudinaryImage.Description != undefined ? cloudinaryImage.CloudinaryImage.Description : "Image " + $scope.activeImageIndex;

                // awards
                $scope.productAwardLocalized = res.data.ProductAwardLocalized;
                $scope.productAwardsLocalized = res.data.ProductAwardsLocalized;

            }
        });
    }

    $scope.partnumbersByColor = function () {
        var temp = [];
        for (i = 0; i < $scope.partnumbers.length; i++) {
            if ($scope.color == "one-color" || $scope.partnumbers[i].color.toLowerCase() == $scope.color.toLowerCase()) {
                temp.push($scope.partnumbers[i]);
            }
        }
        if ($scope.hasVariations && $scope.partnumber.code != null) {

            var cloudinaryImage = $scope.cloudinaryImageByPartnumberCode($scope.partnumber.code);
            $scope.activeImageMain = cloudinaryImage.CloudinaryImage.ImageUrlMain;
            $scope.activeImageLarge = $scope.product.EnableImageByTransformation ? cloudinaryImage.CloudinaryImage.ImageUrlLargeByTransformation : cloudinaryImage.CloudinaryImage.ImageUrlLarge;
            $scope.activeImageSmall = cloudinaryImage.CloudinaryImage.ImageUrlSmall;
            $scope.activeImageThumb = $scope.product.EnableImageByTransformation ? cloudinaryImage.CloudinaryImage.ImageUrlThumbByTransformation : cloudinaryImage.CloudinaryImage.ImageUrlThumb;
            $scope.activeImageZoom = $scope.product.EnableImageByTransformation ? cloudinaryImage.CloudinaryImage.ImageUrlMegaZoomByTransformation : cloudinaryImage.CloudinaryImage.ImageUrlMegaZoom;
            // set index
            $scope.activeImageIndex = $scope.product.CloudinaryImagesToPartnumbers.indexOf(cloudinaryImage);
            // alt text
            $scope.activeImageAltText = cloudinaryImage.CloudinaryImage.Description != undefined ? cloudinaryImage.CloudinaryImage.Description : "Image " + $scope.activeImageIndex;

        }

        return temp;
    }

    $scope.cloudinaryImageByPartnumberCode = function (partnumberCode) {
        for (i = 0; i < $scope.product.CloudinaryImagesToPartnumbers.length; i++) {
            for (var j = 0; j < $scope.product.CloudinaryImagesToPartnumbers[i].PartnumberCodes.length; j++) {
                if ($scope.product.CloudinaryImagesToPartnumbers[i].PartnumberCodes[j] == partnumberCode) {
                    return $scope.product.CloudinaryImagesToPartnumbers[i];
                }
            }
        }
    }

    $scope.selectColor2 = function (cloudinaryImage) {

        $scope.partnumber = '';
        $scope.partnumberCode = '';
        $scope.localdealers = [];
        $scope.localdealersCountFiltered = 0;
        if ($scope.color != undefined && $scope.color.length > 0 && $scope.product.CloudinaryImagesToPartnumbers != undefined && $scope.product.CloudinaryImagesToPartnumbers.length > 0) {
            if (cloudinaryImage == null) {
                cloudinaryImage = $scope.cloudinaryImageByPartnumberCode($scope.partnumbersByColor()[0].code);
            }
            // Check if cloudinaryImage object is found. If not, then probably the partnumbercodes are not linked yet to the cloudinary images. Show first image found in this case.
            if (!cloudinaryImage) {
                cloudinaryImage = $scope.product.CloudinaryImagesToPartnumbers[0];
            }

            $scope.activeImageMain = cloudinaryImage.CloudinaryImage.ImageUrlMain;
            $scope.activeImageLarge = $scope.product.EnableImageByTransformation ? cloudinaryImage.CloudinaryImage.ImageUrlLargeByTransformation : cloudinaryImage.CloudinaryImage.ImageUrlLarge;
            $scope.activeImageSmall = cloudinaryImage.CloudinaryImage.ImageUrlSmall;
            $scope.activeImageThumb = $scope.product.EnableImageByTransformation ? cloudinaryImage.CloudinaryImage.ImageUrlThumbByTransformation : cloudinaryImage.CloudinaryImage.ImageUrlThumb;
            $scope.activeImageZoom = $scope.product.EnableImageByTransformation ? cloudinaryImage.CloudinaryImage.ImageUrlMegaZoomByTransformation : cloudinaryImage.CloudinaryImage.ImageUrlMegaZoom;

            // index
            $scope.activeImageIndex = $scope.product.CloudinaryImagesToPartnumbers.indexOf(cloudinaryImage);

            // alt text
            $scope.activeImageAltText = cloudinaryImage.CloudinaryImage.Description != undefined ? cloudinaryImage.CloudinaryImage.Description : $scope.product.Name;

        }

        if ($scope.partnumbersByColor().length == 1) {
            $scope.partnumberCode = $scope.partnumbersByColor()[0].code;
            $scope.partnumber = $scope.partnumbersByColor()[0];
            $scope.selectPartnumber();
        } else if (cloudinaryImage != null && $scope.hasVariations && $scope.colors.length == 1) {
            //speciaal voor producten als wheelsystems
            for (var i = 0; i < cloudinaryImage.PartnumberCodes.length; i++) {
                for (var j = 0; j < $scope.partnumbers.length; j++) {
                    if ($scope.partnumbers[j].code == cloudinaryImage.PartnumberCodes[i]) {
                        $scope.partnumberCode = cloudinaryImage.PartnumberCodes[i];
                        $scope.selectPartnumber();
                        break;
                    }
                }
            }
        } else {

        }

        setTimeout(function () {
            angular.element('#colorSelect .selectpicker').selectpicker('refresh');
            angular.element('#partnumberSelect .selectpicker').selectpicker('refresh');
        });
        //setTimeout(function () {
        //    angular.element('.selectpicker').selectpicker('refresh');
        //    //angular.element('#partnumberSelect .selectpicker').selectpicker('refresh');
        //});
    }

    $scope.selectPartnumber = function () {
        for (i = 0; i < $scope.partnumbers.length; i++) {
            if ($scope.partnumbers[i].code == $scope.partnumberCode) {
                $scope.partnumber = $scope.partnumbers[i];
                break;
            }
        }
        if ($window.store != undefined && $window.store.length > 0) {
            //It's not necessary to retrieve other stores
        } else {
            if ($scope.product.ProductType == 1 || $scope.useLocalStockGear) {
                if ($scope.partnumber != null) {
                    $scope.getLocalDealers();
                    $scope.getDealers(null, null, true);
                } else {
                    $scope.localdealers = [];
                    $scope.localdealersCountFiltered = 0;
                }
            }
        }

        $scope.supplementaryItemPartnumberCode = '';
        setTimeout(function () {
            angular.element('#supplementaryItemSelect .selectpicker').selectpicker('refresh');
        });

        //track GA
        trackEventGlobalAndLocal('Select your size', 'Click', document.title);

        //GA4
        if ($scope.partnumbers.length > 1) {
            trackEventGlobalAndLocalGA4({ 'ga4_name': 'select_size', 'ga4_model_category': $scope.modelcategory, 'ga4_model_name': $scope.product.Name, 'ga4_click_text': $scope.partnumber.description });
        }
    }

    $scope.selectSupplementaryItem = function () {
        if ($scope.supplementaryItemPartnumberCode) {
            for (var i = 0; i < $scope.partnumber.supplementaryGroup.items.length; i++) {
                if ($scope.partnumber.supplementaryGroup.items[i].code == $scope.supplementaryItemPartnumberCode) {
                    $scope.supplementaryItem = $scope.partnumber.supplementaryGroup.items[i];
                    break;
                }
            }
        }
    }

    $scope.addCartItem = function (dealerCode) {
        //if ($scope.product.ProductType == 3) {
        //    $scope.errorGiftcard = '';
        //    $scope.addCartItemError = '';
        //    if ($scope.formGiftcard.$valid == false) {
        //        $scope.errorGiftcard = lblRequiredFields;
        //        angular.element('input.ng-invalid').first().focus();
        //        return;
        //    }
        //    if ($scope.GiftcardPrice == undefined || $scope.GiftcardPrice.length == 0) {
        //        $scope.errorGiftcard = window.lblNoAmount;
        //        angular.element('input.ng-invalid').first().focus();
        //        return;
        //    }
        //    if ($scope.GiftcardPrice < 1 || $scope.GiftcardPrice > 10000) {
        //        $scope.errorGiftcard = window.lblMaxMinAmount;
        //        angular.element('input.ng-invalid').first().focus();
        //        return;
        //    }
        //}
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/addcartitem' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            var data = {
                productId: $scope.product.Id,
                partnumberCode: $scope.partnumber.code,
                productType: $scope.product.ProductType,
                quantity: 1,
                globalCatalogue: $scope.product.IsGlobalCatalogue,
                GAclientId: $scope.GAclientId(),
                supplementaryItemPartnumberCode: $scope.supplementaryItemPartnumberCode 
                //giftcardPrice: $scope.GiftcardPrice,
                //giftcardRecipientFirstname: $scope.GiftcardRecipientFirstname != undefined ? $scope.GiftcardRecipientFirstname : '',
                //giftcardRecipientLastname: $scope.GiftcardRecipientLastname != undefined ? $scope.GiftcardRecipientLastname : '',
                //giftcardRecipientEmail: $scope.GiftcardRecipientEmail != undefined ? $scope.GiftcardRecipientEmail : '',
                //giftcardMessage: $scope.GiftcardMessage != undefined ? $scope.GiftcardMessage : '',
                //giftcardSenddate: $scope.GiftcardSenddate != undefined ? $scope.GiftcardSenddate : '',
                //giftcardBrand: $scope.GiftcardBrand != undefined ? $scope.GiftcardBrand : ''
            };
            if (dealerCode != null) {
                data["dealerCode"] = dealerCode;
            }

            $http({
                method: 'POST',
                url: url,
                cache: false,
                withCredentials: true,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: data
                //data: { productId: $scope.product.Id, partnumberCode: $scope.partnumber.code, productType: $scope.product.ProductType, quantity: 1, dealerCode: (dealerCode != null ? dealerCode : null), globalCatalogue: $scope.product.IsGlobalCatalogue, GAclientId: $scope.GAclientId(), supplementaryItemPartnumberCode: $scope.supplementaryItemPartnumberCode },
            }).then(function (res) {
                angular.element('#ModalLocalStockFinder').modal('hide');
                if (res.data.result > 0) {

                    var cart = angular.element(document.getElementById('app-cart')).scope();
                    cart.getCartSummary();
                    //angular.element(document.getElementById('app-cart')).scope().$emit('getCartSummary');
                    //$rootScope.$broadcast('cartUpdated');

                    angular.element('#cartModal').modal('show');

                    //GA4
                    var items = [];
                    items.push({
                        //'item_id': $scope.product.ProductType == 3 ? 'giftcard-' + $scope.GiftcardPrice : (($scope.product.ProductType == 1 ? 'bikemodel-' : 'gearproduct-') + $scope.product.Id.toString()),
                        'item_id': (($scope.product.ProductType == 1 ? 'bikemodel-' : 'gearproduct-') + $scope.product.Id.toString()),
                        'item_name': $scope.product.Name != undefined ? $scope.product.Name.toLowerCase() : $scope.product.ProductType == 3 ? 'digital gift card or tradeup voucher' : '',
                        'discount': $scope.partnumber.discount,
                        'index': 0,
                        'item_brand': ($scope.product.BrandName != undefined ? $scope.product.BrandName : window.divisionFullName).toLowerCase(),
                        'item_category': $scope.product._pagecategory != undefined && $scope.product._pagecategory.length > 0 ? $scope.product._pagecategory[0].GA_label.toLowerCase() : 'n/a',
                        'item_category2': $scope.product._pagecategory != undefined && $scope.product._pagecategory.length > 1 ? $scope.product._pagecategory[1].GA_label.toLowerCase() : 'n/a',
                        'item_category3': $scope.product._pagecategory != undefined && $scope.product._pagecategory.length > 2 ? $scope.product._pagecategory[2].GA_label.toLowerCase() : 'n/a',
                        'item_variant': $scope.partnumber.code.length > 0 ? ($scope.partnumber.description + ($scope.partnumber.color != undefined && $scope.partnumber.color.length > 0 ? ' ' + $scope.partnumber.color : '')).toLowerCase() : '',
                        //'price': $scope.product.ProductType == 3 ? $scope.GiftcardPrice : $scope.partnumber.priceOriginal > 0 ? $scope.partnumber.priceOriginal : $scope.partnumber.price,
                        'price': $scope.partnumber.priceOriginal > 0 ? $scope.partnumber.priceOriginal : $scope.partnumber.price,
                        'quantity': 1
                    });
                    trackEventGlobalAndLocalGA4({
                        'ga4_name': 'add_to_cart',
                        'ga4_currency': window.currencyCode,
                        'ga4_value': $scope.partnumber.price,
                        'ga4_items': items
                    });

                    //post to Facebook
                    try {
                        var preferences = $.gdprcookie.preference();
                        if (preferences.indexOf('marketing') > -1) {
                            fbq('track', 'AddToCart', {
                                content_name: $scope.product.Name,
                                content_ids: [$scope.partnumber.code],
                                content_type: 'product',
                                value: $scope.partnumber.price,
                                currency: window.currencyCode
                            });
                        }
                    } catch (e) {
                    }

                    //post to Klaviyo
                    try {
                        waitUntilElementLoad('klaviyo', 2000, function () {
                            var _cartitems = [];
                            if (cart.Cart.CartItems != undefined) {
                                for (var i = 0; i < cart.Cart.CartItems.length; i++) {
                                    var cartItem = cart.Cart.CartItems[i];
                                    var item = {
                                        "ProductID": cartItem.Product.Id,
                                        "SKU": cartItem.Product.Partnumber.Code,
                                        "ProductName": cartItem.Product.Name,
                                        "Quantity": cartItem.Quantity,
                                        "ItemPrice": cartItem.Product.Partnumber._price,
                                        "RowTotal": cartItem.Total,
                                        "ProductURL": cartItem.Product.UrlLabel,
                                        "ImageURL": cartItem.Product.ImageBig,
                                    };
                                    _cartitems.push(item);
                                }
                            }
                            klaviyo.push(["track", "Added to Cart", {
                                "$value": $scope.partnumber.price,
                                "AddedItemProductName": $scope.product.Name,
                                "AddedItemProductID": $scope.product.Id,
                                "AddedItemSKU": $scope.partnumber.code,
                                "AddedItemImageURL": $scope.product.Image,
                                "AddedItemURL": window.masterDomain + '/' + window.culture + '/' + $scope.product.UrlLabel,
                                "AddedItemPrice": $scope.partnumber.price,
                                "AddedItemQuantity": 1,
                                "CheckoutURL": window.masterDomain + '/' + window.culture + '/shop/review',
                                "Items": _cartitems
                            }]);
                            log('klaviyo sent Added to Cart');
                        }, function () {
                            if (readCookie('cookieControlPrefs') != null) {
                                var preferences = $.gdprcookie.preference();
                                if (preferences.indexOf('statistics') == -1 || preferences.indexOf('marketing') == -1) {
                                    return true;
                                }
                            }
                            return false;
                        });
                    } catch (e) {
                    }
                } else {
                    angular.element('#cartModalError').modal('show');
                    //if ($scope.GiftcardRecipientEmail != undefined) {
                    //    $scope.errorGiftcard = res.data.exceptionmessage;
                    //}
                    $scope.addCartItemError = res.data.exceptionmessage;
                }
            });
        });
    }

    $scope.changeColorDropdown = function (cloudinaryImageToPartnumbers) {

        if (cloudinaryImageToPartnumbers.Color != null && cloudinaryImageToPartnumbers.Color.length > 0) {
            //image related to partnumber
            $scope.color = cloudinaryImageToPartnumbers.Color;
            $scope.selectColor2(cloudinaryImageToPartnumbers);

            setTimeout(function () {
                angular.element('#colorSelect .selectpicker').selectpicker('refresh');
            });
        } else {
            //image NOT related to partnumber
            if ($scope.colors.length > 1) {
                //nodig indien een foto is aangeklikt die niet gerelateerd is aan een kleur.
                $scope.color = '';
            }

            $scope.activeImageMain = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlMain;
            $scope.activeImageLarge = $scope.product.EnableImageByTransformation ? cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlLargeByTransformation : cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlLarge;
            $scope.activeImageSmall = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlSmall;
            $scope.activeImageThumb = $scope.product.EnableImageByTransformation ? cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlThumbByTransformation : cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlThumb;
            $scope.activeImageZoom = $scope.product.EnableImageByTransformation ? cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlMegaZoomByTransformation : cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlMegaZoom;

            // index
            $scope.activeImageIndex = $scope.product.CloudinaryImagesToPartnumbers.indexOf(cloudinaryImageToPartnumbers);

            // alt text
            $scope.activeImageAltText = cloudinaryImageToPartnumbers.CloudinaryImage.Description != undefined ? cloudinaryImageToPartnumbers.CloudinaryImage.Description : "Image " + $scope.activeImageIndex;

            // select color
            $scope.selectColor2(cloudinaryImageToPartnumbers);


        }
    };

    $scope.changeZoomedImageModal = function (cloudinaryImageToPartnumbers) {
        $scope.activeImageZoom = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlMegaZoom;
    };


    $scope.compare = function (e) {
        var data = {
            globalcatalogue: $scope.product.IsGlobalCatalogue == true ? "True" : "False",
            id: $scope.product.Id,
            image: $scope.product.Image,
            name: $scope.product.Name
        };

        window.compareStore.add(data);
    }

    $scope.sendStockAlert = function () {
        $scope.errorStockAlert = '';
        if ($scope.formStockAlert.$valid) {
            $scope.dealercity = $scope.notificationZipcode;
            $scope.getGeolocation(function () {
                cartService.MasterDomain().then(function () {
                    var url = cartService._masterDomain + '/' + $window.culture + '/shop/stockalert' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                    $http({
                        method: 'POST',
                        url: url,
                        cache: false,
                        withCredentials: true,
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        transformRequest: function (obj) {
                            //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                            var str = [];
                            for (var p in obj)
                                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                            return str.join("&");
                        },
                        data: { partnumberCode: $scope.partnumber.code, email: $scope.notificationEmail, zipcode: $scope.notificationZipcode, latitude: $scope.latitude, longitude: $scope.longitude },
                    }).then(function (res) {
                        if (res.data == "True") {
                            angular.element('#stockAlertModal').modal('hide');

                            trackEventGlobalAndLocalGA4({ 'ga4_name': 'notify_me', 'ga4_model_category': $scope.modelcategory, 'ga4_model_name': $scope.modelname });
                        } else {
                            $scope.errorStockAlert = res.data;
                        }
                    });
                });
            });
        } else {
            if ($scope.formStockAlert.$error.required != undefined && $scope.formStockAlert.$error.required.length > 0) {
                $scope.errorStockAlert += lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formStockAlert.$error.email != undefined && $scope.formStockAlert.$error.email.length > 0) {
                $scope.errorStockAlert += lblWrongEmailHasBeenEntered;
            }
        }
    }

    $scope.sendContactForm = function () {
        $scope.errorContact = '';
        $scope.isSending = true;
        $scope.formHasBeenSent = false;
        if ($scope.formContact.$valid) {
            var url = '/' + $window.culture + '/contact/sendjson';
            $http({
                method: 'POST',
                url: url,
                cache: false,
                withCredentials: true,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: { Name: $scope.contactName, email: $scope.contactEmail, phone: $scope.contactPhone, size: $scope.contactSize, question: $scope.contactQuestion, ProductId: $scope.contactProductId, ProductType: $scope.contactProductType, isGlobalCatalogue: $scope.contactIsGlobalCatalogue },
            }).then(function (res) {
                if (res.data == "True") {
                    $scope.formHasBeenSent = true;
                    $timeout(function () {
                        angular.element('#contactModal').modal('hide');
                    }, 2000);
                    // succes enable button - maybe not necessary?
                    $scope.isSending = false;

                } else {
                    $scope.errorContact = res.data;
                }
            });
        } else {
            if ($scope.formContact.$error.required != undefined && $scope.formContact.$error.required.length > 0) {
                $scope.errorContact += lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formContact.$error.email != undefined && $scope.formContact.$error.email.length > 0) {
                $scope.errorContact += lblWrongEmailHasBeenEntered;
            }
            // not valid enable button to send again
            $scope.isSending = false;
        }

    }

    $scope.IsMobile = function () {
        return helpers.isMobile();
    }

    $scope.isIOS = function () {
        if (window.ApplePaySession) {
            //alert("canMakePaymentsWithActiveCard");
            var merchantIdentifier = 'merchant.giant-bicycles.com';
            var promise = ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
            //alert(promise);
            promise.then(function (canMakePayments) {
                //alert(canMakePayments);
                if (canMakePayments) {
                    $scope.IOS = true;
                    //HTMLCollection.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
                    //var buttons = document.getElementsByClassName("apple-pay-button");
                    //for (let button of buttons) {
                    //    button.className += " visible";
                    //}
                }
            });
        } else {
            //alert('NO');
            //return false;
        }
    }

    $scope.getPaymentOption = function (code) {
        if ($scope.Cart.PaymentOptions != null) {
            for (var i = 0; i < $scope.Cart.PaymentOptions.length; i++) {
                if ($scope.Cart.PaymentOptions[i].code == code && $scope.Cart.PaymentOptions[i].show == true && ($scope.Cart.PaymentOptions[i].MobileOnly == false || isMobile())) {
                    return $scope.Cart.PaymentOptions[i];
                }
            }
        }
    }

    $scope.setPaymentOptionDisabled = function (code) {
        if ($scope.Cart.PaymentOptions != null) {
            for (var i = 0; i < $scope.Cart.PaymentOptions.length; i++) {
                if ($scope.Cart.PaymentOptions[i].code == code) {
                    $scope.Cart.PaymentOptions[i].disabled = true;
                    try {
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    } catch (e) {
                        //just ignore
                        //log(e);
                    }
                }
            }
        }
    }

    $scope.setPaymentOptionEnabled = function (code) {
        if ($scope.Cart.PaymentOptions != null) {
            for (var i = 0; i < $scope.Cart.PaymentOptions.length; i++) {
                if ($scope.Cart.PaymentOptions[i].code == code) {
                    $scope.Cart.PaymentOptions[i].disabled = false;
                    try {
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    } catch (e) {
                        //just ignore
                        //log(e);
                    }
                }
            }
        }
    }

    $scope.resetContactInfo = function () {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/resetcontactinfo';
            $http({
                method: 'POST',
                url: url,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                withCredentials: true
            }).then(function (res) {
                location.reload();
            });
        });
    }

    $scope.selectPartnumberByBarcode = function (barcode) {
        for (i = 0; i < $scope.partnumbers.length; i++) {
            if ($scope.partnumbers[i].barcode == barcode) {
                $scope.partnumberCode = $scope.partnumbers[i].code
                $scope.partnumber = $scope.partnumbers[i];
                $scope.selectPartnumber();
                setTimeout(function () {
                    angular.element('#sizes.selectpicker').selectpicker('refresh');
                });
                break;
            }
        }
    }

    $scope.selectPartnumberByCode = function (sizingPartnumberCodes) {
        var partnumbersByColor = $scope.partnumbersByColor();
        for (var i = 0; i < partnumbersByColor.length; i++) {
            for (var j = 0; j < sizingPartnumberCodes.length; j++) {
                if (sizingPartnumberCodes[j] == partnumbersByColor[i].code) {
                    $scope.partnumberCode = partnumbersByColor[i].code
                    $scope.partnumber = partnumbersByColor[i];
                    $scope.selectPartnumber();
                    setTimeout(function () {
                        angular.element('#sizes.selectpicker').selectpicker('refresh');
                    });
                    break;
                }
            }
        }
    }

    $scope.validateAddress = function () {
        if (validateAddressHousenumber && $scope.Cart.Order != null && $scope.Cart.Order.Street != null && $scope.Cart.Order.Street.length > 0) {
            $scope.containsValidAddress = /\d/.test($scope.Cart.Order.Street);
        }
    }

    $scope.runAwardClick = function (awardUrl, openInNewWindow) {

        if (awardUrl != undefined && awardUrl.length > 0) {
            // track click
            trackEventGlobalAndLocal('Award', 'Click', awardUrl);
            // go to url
            if (openInNewWindow) {
                $window.open(awardUrl, '_blank');
            } else {
                $window.open(awardUrl, '_self');
            }
        }
    }

    $scope.getBrowserlocation = function () {
        helpers.getBrowserLocation(function (lat, lng, dealercity) {
            $scope.latlng = lat + ',' + lng;
            $scope.dealercity = dealercity;
            $scope.$apply();
            $('#latlng').val($scope.latlng);
            $('#keyword').val($scope.dealercity);
            $('form#Geocoder').submit();
        });
    }

    $scope.getGeolocationStoreMinimal = function () {
        helpers.getGeolocation($scope.dealercity, function (lat, lng) {
            $scope.latlng = lat + ',' + lng;
            $scope.$apply();
            $('#latlng').val($scope.latlng);
            log('Search: ' + $scope.dealercity + ' ' + $scope.country + ', Result: ' + $scope.latlng);
            $('form#Geocoder').submit();
        });
    };

    $scope.changeTaxDocument = function () {
        if ($scope.Cart.Order.TaxDocument == false) {
            $scope.Cart.Order.ClientType = '';
            $scope.Cart.Order.VATNum = '';
            $scope.Cart.Order.VATName = '';
        } else {
            $scope.Cart.Order.ClientType = 'individual';
        }
    }

    //$scope.otherAmountClick = function () {
    //    $scope.otherAmountClicked = true;
    //    $scope.GiftcardPrice = '';
    //    setTimeout(function () {
    //        $('#otheramount').focus();
    //    });
    //}

    //$scope.amountClick = function (amount) {
    //    $scope.GiftcardPrice = amount;
    //    $scope.otherAmountClicked = false;
    //    $scope.giftcardradio = amount;
    //}

    //$scope.getGiftcardBalance = function () {
    //    if ($scope.GiftcardNumber && $scope.GiftcardNumber.length > 0) {
    //        $scope.GiftcardValue = '';
    //        $scope.errorGiftcardBalance = '';
    //        $scope.GiftcardExpirationDate = '';

    //        grecaptcha.ready(function () {
    //            grecaptcha.execute(window.GoogleRecaptchaSiteKey, { action: 'social' })
    //                .then(function (token) {
    //                    var url = '/' + $window.culture + '/giftcard/balance';
    //                    $http({
    //                        method: 'POST',
    //                        url: url,
    //                        cache: false,
    //                        withCredentials: true,
    //                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    //                        transformRequest: function (obj) {
    //                            //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
    //                            var str = [];
    //                            for (var p in obj)
    //                                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    //                            return str.join("&");
    //                        },
    //                        data: { GiftcardNumber: $scope.GiftcardNumber, Token: token }
    //                    }).then(function (res) {
    //                        $scope.GiftcardValue = res.data.result;
    //                        $scope.errorGiftcardBalance = res.data.exception;
    //                        $scope.GiftcardExpirationDate = res.data.expirationdate;
    //                        $scope.GiftcardNumber = '';
    //                        $('.giftcardnumber').focus();
    //                    });
    //                });
    //        });
    //    }
    //}

    $scope.GetGACartItems = function () {
        var result = [];
        for (var i = 0; i < $scope.Cart.CartItems.length; i++) {
            var cartItem = $scope.Cart.CartItems[i];
            var item = {
                //'item_id': cartItem.Product.ProductTypeId == 3 ? 'giftcard-' + cartItem.Product.PriceOriginal : ((cartItem.Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + cartItem.Product.GA_ProductId.toString()),
                'item_id': ((cartItem.Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + cartItem.Product.GA_ProductId.toString()),
                'item_name': cartItem.Product.Name != undefined ? cartItem.Product.Name.toLowerCase() : cartItem.Product.ProductType ? 'digital gift card or tradeup voucher' : '',
                'discount': cartItem.Product.Partnumber != null && cartItem.Product.PriceOriginal > 0 ? cartItem.Product.PriceOriginal - cartItem.Product.Partnumber._price : 0,
                'index': 0,
                'item_brand': (cartItem.Product.BrandName != null ? cartItem.Product.BrandName : window.divisionFullName).toLowerCase(),
                'item_category': cartItem.Product.PageCategories != null && cartItem.Product.PageCategories.length > 0 ? cartItem.Product.PageCategories[0].GA_label.toLowerCase() : 'n/a',
                'item_category2': cartItem.Product.PageCategories != null && cartItem.Product.PageCategories.length > 1 ? cartItem.Product.PageCategories[1].GA_label.toLowerCase() : 'n/a',
                'item_category3': cartItem.Product.PageCategories != null && cartItem.Product.PageCategories.length > 2 ? cartItem.Product.PageCategories[2].GA_label.toLowerCase() : 'n/a',
                'item_variant': cartItem.Product.Partnumber.Code.length > 0 ? (cartItem.Product.Partnumber != null ? cartItem.Product.Partnumber.Size.toLowerCase() + (cartItem.Product.Partnumber.Color.length > 0 ? ' ' + cartItem.Product.Partnumber.Color.toLowerCase() : '') : '') : '',
                'quantity': cartItem.Quantity,
                'price': cartItem.Product.PriceOriginal != undefined && cartItem.Product.PriceOriginal > 0 ? cartItem.Product.PriceOriginal : cartItem.Product.Partnumber.PriceOriginal,
            };
            result.push(item);
        }
        return result;
    }

    $scope.GetFirstBikePartnumber = function () {
        var result = '';
        if ($scope.Cart.CartItems != undefined) {
            for (var i = 0; i < $scope.Cart.CartItems.length; i++) {
                if ($scope.Cart.CartItems[i].Product.ProductTypeId == 1) {
                    result = $scope.Cart.CartItems[i].Product.Partnumber.Code;
                }
            }
        }
        return result;
    }

    $scope.GetProductByPartnumberCode = function (code) {
        var result = '';
        if ($scope.Cart.CartItems != undefined) {
            for (var i = 0; i < $scope.Cart.CartItems.length; i++) {
                if ($scope.Cart.CartItems[i].Product.Partnumber.Code == code) {
                    result = $scope.Cart.CartItems[i].Product;
                }
            }
        }
        return result;
    }

    $scope.PostForm = function (url, data) {
        // Create a form
        var form = document.createElement('form');
        form.method = 'POST';
        form.action = url;

        // Add the form data as hidden fields
        for (var i = 0; i < data.length; i++) {
            var hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = data[i].Key;
            hiddenField.value = data[i].Value;
            form.appendChild(hiddenField);
        }

        // Append the form to the body and submit it
        document.body.appendChild(form);
        form.submit();
    }

    $scope.LoginGiantId = function () {
        $scope.completeInProgress = true;

        //track GA
        trackEventGlobalAndLocal('Log in GiantID', 'Click', 'Checkout');
    }

    $scope.RegisterGiantId = function () {
        $scope.completeInProgress = true;

        //track GA
        trackEventGlobalAndLocal('Register GiantID', 'Click', 'Checkout');
    }
}]);

angular.element(document).ready(function () {
    try {
        var appID = document.getElementById('app-shop');
        angular.bootstrap(appID, ['app-shop']);
    } catch (e) {
        //do nothing
    }
});